// ecomTheme functions

window.ecomTheme = window.ecomTheme || {};
/*Dropdown Menu*/
$('.currency-dropdown').click(function () {
  $(this).attr('tabindex', 1).focus();
  $(this).toggleClass('active');
  $(this).find('.currency-dropdown-menu').slideToggle(300);
});
$('.currency-dropdown').focusout(function () {
  $(this).removeClass('active');
  $(this).find('.currency-dropdown-menu').slideUp(300);
});
$('.currency-dropdown .currency-dropdown-menu li').click(function () {
  var datavalue = $(this).attr('data-value');
  $('.currencies').val(datavalue);
  $('.currencies').trigger('change');
  $.cookie("ecomcookie", datavalue, {
    path    : '/',  
  });  
  // alert($.cookie("ecomcookie"));
  $(".ecom-flag .selected-ecom-flag").each(function(index, element) {
    var flag_list = $(this).data('value'); 
    if(datavalue == flag_list){
      $('.ecom-flag .selected-ecom-flag').hide();
      $(".ecom-flag .selected-ecom-flag.ecom-"+flag_list).show(); 
    } 
  });
});

(function($){var component2=$("#header");var state="BEFORE_SCROLL";var component=$("#main");var page=$("#page");var body=$("body");var burger=$('.header__nav-button');var blurZone=$("<div class='nav-blur-zone'></div>");var isOpen=false;var activeElement=null;var mode=$(window).innerWidth()>=992?"PC":"MOBILE";function open(){if(isOpen==false){isOpen=true;body.css("overflow","hidden");component.addClass("nav_open");blurZone.prependTo("#page")}}function close(){if(isOpen==true){isOpen=false;body.css("overflow","auto");component.removeClass("nav_open");blurZone.remove()}}function changeState(){component2.css('transitionDuration','0.4s');if(pageYOffset>=30&&state==="BEFORE_SCROLL"){state="AFTER_SCROLL";console.log(pageYOffset);console.log("scrolling",state);component2.addClass("is_sticky")}else if(pageYOffset<30&&state==="AFTER_SCROLL"){state="BEFORE_SCROLL";console.log(pageYOffset);console.log("not scrolling",state);component2.removeClass("is_sticky")}}$(window).on('scroll',function(){changeState()});$(document).ready(function(){changeState()});$('body').on('click','.nav-blur-zone',function(){close()});$('body').on('click','.header__nav-button',function(e){$('#main').toggleClass('nav_open')});$(".product-template .input-number-wrap .fa").on("click",function(){var $button=$(this);var oldValue=$button.parent('.input-number-wrap').find("input").val();if($button.hasClass('fa-plus')){var newVal=parseFloat(oldValue)+1}else{if(oldValue>1){var newVal=parseFloat(oldValue)-1}else{newVal=1}}$button.parent().find("input").val(newVal)});$("#cart_form .input-number-wrap .fa").on("click",function(){var $button=$(this);var oldValue=$button.parent('.input-number-wrap').find("input").val();if($button.hasClass('fa-plus')){var newVal=parseFloat(oldValue)+1}else{if(oldValue>0){var newVal=parseFloat(oldValue)-1}else{newVal=0}}$button.parent().find("input").val(newVal)});var mode=$(window).innerWidth()>=992?"PC":"MOBILE";if(mode=="PC"){}else if(mode=="MOBILE"){
  $('ul.metismenu>li.dropdown>a, ul.metismenu li.mega-drop-down .dropdown-toggle').off('hover');
  $('ul.metismenu li.dropdown .dropdown-toggle').on('click',function(){
    $(this).toggleClass("highlight");
    $(this).parent().find('.dropdown-menu').slideToggle(300);
    return false;
  })
  $('ul.metismenu li.mega-drop-down .dropdown-toggle').on('click',function(){
    $(this).toggleClass("highlight");
    $(this).parent().find('.mega-menu').slideToggle(300);
    return false;
  })

}})(jQuery);
/* Newsletter Popup */
//var ecom_newsletter_popup={init:function(){var popup=Cookies.get('popup');var cookie_enabled=false;if(cookie_enabled&&popup=='open'){return false}else{ecom_newsletter_popup.open()}if(cookie_enabled){Cookies.set('popup','open',{expires:1})}},open:function(){if(false||$(window).width()>798){setTimeout(function(){$('[data-remodal-id=newsletter]').remodal().open()},2*1000)}}}
var ecom_newsletter_popup = {
  init: function(){
    var popup = Cookies.get('popup');
    var cookie_enabled = true;

    if (cookie_enabled && popup == 'open') {
      return false;
    } else {
      ecom_newsletter_popup.open();
    }
    if (cookie_enabled) {
      Cookies.set('popup', 'open', { expires: 1 });
                                   }
                  },
                  open: function(){
        if (false || $(window).width() > 768) {
          setTimeout( function() {
            $('[data-remodal-id=newsletter]').remodal().open();
          },
                     0*1000);
        }
      }
    }
    /**Timer**/
    var ecomtimer = {
      init: function(){
          
        // for minute
        var myMinute = ['10','15', '20', '25', '30', '45','60','90','120','180','300','420','600','720'];    

        var randMinute = Math.floor(Math.random() * myMinute.length); 
        //1
        var currentMinute = myMinute[randMinute];
        var ecomMinute =currentMinute*60;
        var myMinutevar=ecomMinute;
        var time_minute=myMinutevar/60 ; 
        //   alert(time_minute);
        //  alert('ecom_timer_2');
        var hours = Math.floor( time_minute / 60);          
        var minutes = Math.floor(time_minute % 60);     

        $('.ecom_timer').countdowntimer({
          hours : hours,
          minutes :minutes,
          seconds :00,
          size : "lg"
        });  

        $('#ecom_timer-page-funnel-template1').countdowntimer({
          hours : hours,
          minutes :minutes,
          seconds :00,
          size : "lg"
        }); 
        $('#ecom_timer-page-funnel-template2').countdowntimer({
          hours : hours,
          minutes :minutes,
          seconds :00,
          size : "lg"
        }); 
        $('#ecom_timer-page-funnel-template3').countdowntimer({
          hours : hours,
          minutes :minutes,
          seconds :00,
          size : "lg"
        }); 
        
      }
    }

    /**QTY SOLD**/
    ecomTheme.setCookie = function (name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    ecomTheme.getCookie = function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    
    var flashQTYSold = {
      init: function(){
        if ($('#TotalSold').length) {
          var minQty = 5;
          var maxQty = 25;
          var minTime = 3;
          var maxTime = 8;
          minQty = Math.ceil(minQty);
          maxQty = Math.floor(maxQty);
          minTime = Math.ceil(minTime);
          maxTime = Math.floor(maxTime);


          var parts = document.location.href.split('/');
          var current_product = parts.pop() || parts.pop();


          var qty = ecomTheme.getCookie('qty'+current_product);
          if (qty == null) {
            var qty = Math.floor(Math.random() * (maxQty - minQty + 1)) + minQty;
            qty = parseInt(qty);
            if(qty <= minQty){
              qty = minQty;
            }
            if(qty > maxQty){
              qty = maxQty;
            }
          }

          jQuery("#TotalSold").html(qty);
          ecomTheme.setCookie('qty'+current_product, qty, 1);
          var time = Math.floor(Math.random() * (maxTime - minTime + 1)) + minTime;
          time = parseInt(time);
          if(time <= minTime){
            time = minTime;
          }
          if(time > maxTime){
            time = maxTime;
          }
          jQuery("#InHours").html(time);
          setInterval(function(){
            $('.flash-fire').fadeIn(function() {
              $(this).css("visibility", "visible");
            }).delay(400).fadeIn(function() {
              $(this).css("visibility", "hidden");
            }).delay(600);
          }, 1000);
        }
      }
    }
     
    /*Progress Bar*/
    var progress_bar = {
      init: function(){
        $(".progress_bar").progressbar();
      }
    }
    /*GDPR*/
    var gdpr = {
      init: function(){
        function TermsAndConditions(){
          days=1;
          myDate = new Date();
          myDate.setTime(myDate.getTime()+(days*24*60*60*1000));
          document.cookie = 'TermsAndConditions=Accepted; expires=' + myDate.toGMTString();
        }

        var cookie = document.cookie.split(';')
        .map(function(x){ return x.trim().split('='); })
        .filter(function(x){ return x[0]==='TermsAndConditions'; })
        .pop();

        if(cookie && cookie[1]==='Accepted') {
          return false;
        } else {
          $(".widget-gpdr-banner").show();
        }

        $('.widget-gpdr-banner__accept').on('click', function(){          
          TermsAndConditions();
          $(".widget-gpdr-banner").hide();
          return false;
        }); 
      }
    }
    /* Visitor Count */
    var ecom_visitor_count={init:function(){var min_visitor=parseInt($('.fake_counter_p').data('min-visitor'));var max_visitor=parseInt($('.fake_counter_p').data('max-visitor'));min_visitor=Math.ceil(min_visitor);max_visitor=Math.floor(max_visitor);var r=Math.floor(Math.random()*(max_visitor-min_visitor+1))+min_visitor;var inc='1';var myRandom=['1','2','-1','-2'];var randomlyValue='';var currentmyRandom='';var plus=['1','2','3'];var range='';setInterval(function(){randomlyValue=Math.floor(Math.random()*myRandom.length);currentmyRandom=myRandom[randomlyValue];r=parseInt(r)+parseInt(currentmyRandom);if(r<=min_visitor){r=min_visitor}if(r>max_visitor){r=max_visitor}jQuery(".fakeCounter").html(r)},30000)}}
    /* Featured collection section */
    var ecom_featured_collection={init:function(){$('.js-product-slider .products-slider, .js-related-products .products-slider').each(function(index,value){var products_per_slide=$(this).data('products-per-slide');var products_limit=$(this).data('products-limit');var products_available=$(this).data('products-available');var owl=$(this).data('products-available');$(this).owlCarousel({nav:true,dots:false,navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],items:products_per_slide,responsive:{0:{items:2},600:{items:3},900:{items:products_per_slide}}})})}}
    /* FAQ */
    var ecom_faqAccordion={init:function(){var flg=0;var $faqHeading=$('.faqAccordion > .faq-box > dt > button');$('.faqAccordion > .faq-box > dd').attr('aria-hidden',true);$faqHeading.attr('aria-expanded',false);$('.faqAccordion .faq-box').each(function(index,value){if(index==0){$(this).addClass('tab-activate');$(this).find('.faq-btn').attr('aria-expanded',true);$(this).find('#panel-01').slideToggle()}});$faqHeading.on('click activate',function(){$(this).parent().parent().addClass("tab-activate").siblings().removeClass("tab-activate");$(this).parent().parent().addClass("tab-activate").siblings().removeClass("tab-activate");if(flg)return false;flg=1;var state=$(this).attr('aria-expanded')==='false'?true:false;$(this).attr('aria-expanded',state);$(this).parent().next().slideToggle(function(){flg=0});$(this).parent().next().attr('aria-hidden',!state);$('.faqAccordion .faq-box').each(function(index,value){if(!$(this).hasClass('tab-activate')){$(this).find('.faq-btn').attr('aria-expanded',false);$(this).find('#panel-01').hide()}})});$faqHeading.on('keydown',function(event){var keyCode=event.keyCode||e.which;if(keyCode===13){$(this).trigger('activate')}})}}
    /*Cart Timer*/
    var ecom_cart_timer={init:function(){var cart_val = $('#cartcount').data('cart-value');if(cart_val>0){function createCookie(a,b,c){if(c){var d=new Date;d.setTime(d.getTime()+60*c*1e3);var e="; expires="+d.toUTCString()}else var e="";document.cookie=a+"="+b+e+"; path=/"}function readCookie(a){for(var b=a+"=",c=document.cookie.split(";"),d=0;d<c.length;d++){for(var e=c[d];" "==e.charAt(0);)e=e.substring(1,e.length);if(0==e.indexOf(b))return e.substring(b.length,e.length)}return null}function eraseCookie(a){createCookie(a,"",-1)}function crtmedir(a){var b=document.createDocumentFragment(),c=document.createElement("div");for(c.innerHTML=a;c.firstChild;)b.appendChild(c.firstChild);return b}function startTimer(a,b,c){function g(){d=b-((Date.now()-a)/1e3|0),e=d/60|0,f=d%60|0,e=e<10?"0"+e:e,f=f<10?"0"+f:f,c.textContent=e+":"+f,d<=0&&(clearInterval(h),document.getElementById("countdownhere").innerHTML=expiry_text,a=Date.now()+1e3)}var d,e,f;g();var h=setInterval(g,1e3)}var timer_text=$(".cart_counter").attr("data-cart_timer_text"),expiry_text=$(".cart_counter").attr("data-cart_expirey_text"),timer_in_seconds=$(".cart_counter").attr("data-cart_timer"),timer_in_minute=timer_in_seconds/60,pdm=crtmedir('<div class="countdownholder"><div id="countdownhere">'+timer_text+' <span id="time"></span></div></div>');window.location.href.indexOf("cart")>-1&&(window.onload=function(){document.getElementsByClassName("cart_counter")[0].appendChild(pdm);var a=timer_in_minute,b=60*a,c=Date.now(),d=readCookie("prtcntdwn");d?c<d?b=(d-c)/1e3:(eraseCookie("ptcntdwn"),createCookie("prtcntdwn",Date.now()+1e3*b,b+1)):createCookie("prtcntdwn",Date.now()+1e3*b,b+1),display=document.querySelector("#time"),startTimer(c,b,display)})}}}
    /* Slideshow */
    var ecom_slideshow={init:function(){$('.js-homepage-slideshow').each(function(index,value){var slideshow_speed=$(this).data('slideshow-speed');var slideshow_arrow=$(this).data('slideshow-arrow');var owl=$(this).data('slider-id');$(this).owlCarousel({nav:slideshow_arrow,dots:true,navText:["&nbsp;","&nbsp;"],items:1,autoplay:true,autoplayTimeout:slideshow_speed*1000,autoplayHoverPause:true})})},unload:function($target){var $slider=$target.find('.js-homepage-slideshow');$slider.owl('destroy')}}
    //Used for cart functionality
    function htmlEncode(value){if(value){return $('<div/>').text(value).html()}else{return''}}
    /**Instagram**/

    var instagram = {
      loadContent: function(s){
        if(s.clientID) {
          var url = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+s.clientID;

          $.ajax({
            type: 'GET',
            url: url,
            dataType: 'jsonp',
            success: function(data) {

              if(data.meta.code === 200 && data.data.length) {
                var data = data.data;
                var count = 0;
                s.el.empty();

                for(var i = 0; i < data.length; i++) {
                  var thisMedia = data[i], item;

                  var url = thisMedia.images.low_resolution.url;

                  if(!thisMedia.images.low_resolution.url.indexOf("null") > -1) {
                    item = '<div class="instagram-img"><a href="'+thisMedia.link+'" target="_blank" id="'+thisMedia.id+'" style="background-image:url('+url+')"></a></div>';
                  }

                  if(thisMedia.videos) {
                    item = '<div class="instagram-img"><a href="'+thisMedia.link+'" target="_blank" id="'+thisMedia.id+'" style="background-image:url('+url+')"></a></div>';
                  }

                  if(item) {
                    item = item;
                  }
                  if(item !== '') {
                    s.el.append(item);
                    count++;
                  }
                  if(count == s.limit) {
                    break;
                  }
                }
              }
            },
            error: function() {
            }
          });
        }
      }
    }
    var social = {
      instagram: function(){
        var $target = $('#instagram_feed_wrap').find(".js-instafeed");
        instagram.loadContent({
          el: $target,
          resolution: $target.data('resolution_images'), 
          clientID: $target.data('client-id'),
          limit: $target.data('count')
        });

      }
    }
    /* Load More items For Search*/
    var ecomhope_LoadMoreSearch = function(){
      $('body').on('click', '.js-load-more a', function(e){
        ecomhope_InfiniteSearchScroll();
        e.stopPropagation();
        return false;
      });
    }
    var ecomhope_InfiniteSearchScroll = function(){
      if ($('.search-matrix').length) {
        var ecomhope_infiniteSearchScroll = new Waypoint.Infinite({
          element: $('.search-matrix')[0],
          items: '.search-matrix',
          more: '.load-more__btn',
          loadingClass: 'loading-in-progress',
          onBeforePageLoad: function(){
            $('.js-load-more').hide();
          },
          onAfterPageLoad: function(data){
            
            SPR.$(document).ready(function() {
              return SPR.registerCallbacks(),
                SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges()
            })
            
             
          }
        })
        }
    }

    /* Load More Products */
    var ecomhope_LoadMoreProducts = function(){
      $('body').on('click', '.js-load-more a', function(e){
        ecomhope_InfiniteScroll();
        e.stopPropagation();
        return false;
      });
    }
    var ecomhope_InfiniteScroll = function(){
      if ($('.collection-matrix').length) {
        var ecomhope_infiniteScroll = new Waypoint.Infinite({
          element: $('.collection-matrix')[0],
          items: '.collection-matrix',
          more: '.load-more__btn',
          loadingClass: 'loading-in-progress',
          onBeforePageLoad: function(){
            $('.js-load-more').hide();
          },
          onAfterPageLoad: function(data){
            $('.collection-matrix > .collection-matrix .product_grid').unwrap('.collection-matrix');
            
            SPR.$(document).ready(function() {
              return SPR.registerCallbacks(),
                SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges()
            })
            
            
            // ecomTheme.geoIP();
          }
        })
        }
    }

    /* Filter Products with AJAX */
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }

    var ecomhope_quickFilter = {
      init: function(){
        var selectedOptions = [],
            query = '',
            currentTags = '',
            siteUrl = 'https://' + $.url('hostname'),
            url1 = $.url('1') ? '/' + $.url('1') + '/' : '',
            url2 = $.url('2') ? $.url('2') + '/' : '',
            url3 = $.url('3'),
            path = url1 + url2;

        //Handle dropdowns if they exist
        if ($('#homepage-sort-by').length){
          query = $('#homepage-sort-by').val();
        } else {
          query = url('?sort_by');
        }


        //Add all checkbox values to array
        $('[data-option-filter] input:checked').each(function (){
          selectedOptions.push($(this).val());
        });
        selectedOptions = $.makeArray(selectedOptions);

        //Loop through tags to create string to update page url
        $.each(selectedOptions, function(i, value){

          if (i != selectedOptions.length - 1) {
            currentTags += selectedOptions[i] + '+';
          } else {
            currentTags += selectedOptions[i];
          }

        });

        Shopify.queryParams.sort_by = query;
        query = '?' + $.param(Shopify.queryParams);

        ecomhope_quickFilter.processUrl(path, currentTags, query);
      },
      ecomhope_updateView: function(filterURL) {

        $.ajax({
          type: 'GET',
          url: filterURL,
          beforeSend: function() {
            $(".collection-matrix").addClass('fadeOut animated loading-in-progress filter-loading');
            Waypoint.destroyAll()
          },
          success: function(data) {
            $(".collection-matrix").removeClass('loading-in-progress');
            $(".collection-matrix").removeClass('filter-loading');
            var filteredBreadcrumb = $(data).find('.breadcrumb_text').html();
            $('.breadcrumb_text').html(filteredBreadcrumb);

            var filteredPagination = $(data).find('.paginate').html();
            $('.paginate').html(filteredPagination);

            var filteredPageLinks = $(data).find('.paginate').html();
            $('.paginate').empty();
            $('.paginate').html(filteredPageLinks);

            var filteredData = $(data).find('.collection-matrix');
            $('.collection-matrix').remove();
            filteredData.insertBefore( $('.load-more__icon') );

            window.history && window.history.pushState && window.history.pushState("", "", filterURL);



            
            ecomhope_InfiniteScroll();
            

            
            
            SPR.$(document).ready(function() {
              return SPR.registerCallbacks(),
                SPR.initRatingHandler(),
                SPR.initDomEls(),
                SPR.loadProducts(),
                SPR.loadBadges()
            })
            
          },
          error: function(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
            location.replace(location.protocol + '//' + location.host + filterURL);

          },
          dataType: "html"
        });
      },
      processUrl: function(path, tags, query){

        var query = query.replace(/\page=(\w+)&/, ''),
            urlString = '';

        urlString = path + tags + query;

        ecomhope_quickFilter.ecomhope_updateView(urlString);

      }
    }
    $('#homepage-sort-by').val($('#homepage-sort-by').data('default-sort'));
    $('body')
    .on('change', '#tag_filter, #homepage-sort-by', function() {
      ecomhope_quickFilter.init();
    });
    /***password**/
    $(function() {
      $('#open-me').on('click', function() { 
        $('.overlay').addClass('overlay-open');
      });

      $('.close-me').on('click', function() {
        $('.overlay').removeClass('overlay-open');
      });
    });
    /* Product page */


    selectCallback = function(variant, selector) {
      var $product = $('.product-' + selector.product.id);
      var $notify_form = $('.notify-form-' + selector.product.id);
      var $productForm = $('.product_form', $product);
      var price_format = $('.product-detail-part').data('price-format');
      var variantInventory = $productForm.data('variant-inventory'); 
      // BEGIN SWATCHES
      
      // END SWATCHES
      if (variant) {
        $('.sku span', $product).text(variant.sku);
        //Variant image
        if (variant && variant.featured_image) {
          var originalImage = $(".product-photo-container img", $product);
          var originalAlt = $(".product-photo-container img", $product).attr('alt');
          var newImage = variant.featured_image;
          var element = originalImage[0];
          Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element, newAltText) {
            $(element).parents('a').attr('data-zoom-image', newImageSizedSrc);
            $(element).attr('src', newImageSizedSrc);
            $(element).attr('data-zoom-image', newImageSizedSrc);
            $(element).attr('alt', newAltText); 
             
                         
            if ($(window).width() >= 767) {
              
              $('.zoomContainer').remove();
              var zoomConfigs = {zoomType : "inner",cursor: "crosshair",responsive: true }; 
              var zoomImages = $('img.product-featured-image', $product);
              zoomImages.data('zoom-image', newImageSizedSrc).elevateZoom(zoomConfigs);//initialise zoom
               
            }
            
             
          });
        }
      }

      if (variant && variant.available == true) { 
        $('.product_price', $product).html('<span class="money">' +Shopify.formatMoney(variant.price, $productForm.data('money-format')) + '</span>');
        if(variant.price < variant.compare_at_price){    
          $('.discount-price', $product).html('<span class="money">' +Shopify.formatMoney(variant.compare_at_price, $productForm.data('money-format')) + '</span>');
          if(price_format == 1){
            $('.save-price', $product).html("You Save" + ' '  + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $productForm.data('money-format')) + '</span>');
          } else {
            $('.save-price', $product).html(((variant.compare_at_price - variant.price)/variant.compare_at_price*100).toFixed()+"% OFF");   
            $('.funnel-save-price', $product).html(((variant.compare_at_price - variant.price)/variant.compare_at_price*100).toFixed()+"% <span>Discount</span>");   
          }      
          $('.save-price', $product).addClass('sale').removeClass('hide');
          $('.funnel-save-price', $product).addClass('sale').removeClass('hide');
        } else { 
          $('.discount-price', $product).html('');
          $('.save-price', $product).removeClass('sale').addClass('hide');
          $('.funnel-save-price', $product).removeClass('sale').addClass('hide');
        }

        if (variant.price > 0) {   
          $('.product_form .cart-btn', $product).attr('data-label',$('.product_form .cart-btn', $product).data('cart-button'));
          $('.product_form .cart-btn', $product).removeClass('free-shipping').removeClass('disabled').removeAttr('disabled').find('span').text($('.cart-btn', $product).data('label'));
        } else {
          $('.product_form .cart-btn', $product).attr('data-label','Free + Shipping');
                                                      $('.product_form .cart-btn', $product).addClass('free-shipping').removeClass('disabled').removeAttr('disabled').find('span').text('Free + Shipping');
                                                                                                                                            }
                                                                                                                                            //  $('.shopify-payment-button', $product).show();
                                                                                                                                            $('.sold_out', $product).text('');
          $notify_form.hide();
        } else {
          var message = variant ? "Sold Out" : "Unavailable";
          $('.sold_out', $product).text(message);
          $('.discount-price', $product).text('');
          $('.save-price', $product).text('').removeClass('sale').addClass('hide');
          $('.funnel-save-price', $product).text('').removeClass('sale').addClass('hide');
          $('.product_price', $product).text(''); 
          $('.product_form .cart-btn', $product).removeClass('free-shipping').addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
          //  $('.shopify-payment-button', $product).hide();
          $notify_form.show();
          if (variant) {
          $notify_form.fadeIn();
          }
          }   
          
          $('.product-photo-thumbs', $product).owlCarousel({
          nav : true,
              dots: false,
                navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
                  items : 6, 
                    responsive:{
                      0:{
                        items:3
                      },
                        600:{
                          items:4
                        },
                          1000:{
                            items:4
                          }
                    }
        });
        $('.description.single-product', $product).readmore({
          speed: 75,
          moreLink: '<a href="#" class="read_more action_button">Read more</a>',
          lessLink: '<a href="#" class="read_more action_button">Read less</a>'
        });

      };  
      var productPage = {
        init: function(){ 
          $(".product-template .product_form_options").each(function() { 
            new Shopify.OptionSelectors($(this).data("select-id"), { 
              product: $(this).data("product"),
              onVariantSelected: selectCallback, 
              enableHistoryState: $(this).data("enable-state") 
            });
          }); 

        }
      }
      /* Upsell Product page */
      upsellSelectCallback = function(variant, selector) { 
        var $upsellProduct = $('.upsell-product-' + selector.product.id);  
        var $upsellProductForm = $('.upsell_product_form', $upsellProduct); 
        if (variant && variant.available == true) {
          $('.upsell-price', $upsellProduct).html('<span class="money">' +Shopify.formatMoney(variant.price, $upsellProductForm.data('money-format')) + '</span>');
          if(variant.price < variant.compare_at_price){     
            $('.discount-price', $upsellProduct).html('<span class="money">' +Shopify.formatMoney(variant.compare_at_price, $upsellProductForm.data('money-format')) + '</span>');
            $('.prod_label span', $upsellProduct).html("You Save" + ' '  + '<span class="money">' + Shopify.formatMoney(variant.compare_at_price - variant.price, $upsellProductForm.data('money-format')) + '</span>');
            $('.prod_label span', $upsellProduct).addClass('sale').removeClass('hide');
          } else { 
            $('.discount-price', $upsellProduct).html('');
            $('.save-price', $upsellProduct).removeClass('sale').addClass('hide');
          }

          if (variant.price > 0) {
            $('.upsell_product_form .cart-btn', $upsellProduct).removeClass('free-shipping').removeClass('disabled').removeAttr('disabled').find('span').text($('.cart-btn', $upsellProduct).data('label'));
          } else {
            $('.upsell_product_form .cart-btn', $upsellProduct).addClass('free-shipping').removeClass('disabled').removeAttr('disabled').find('span').text('Free + Shipping');
		} 
 		$('.sold_out', $upsellProduct).text(''); 
          } else {
            var message = variant ? "Sold Out" : "Unavailable";
            $('.sold_out', $upsellProduct).text(message);
            $('.discount-price', $upsellProduct).text('');
            $('.save-price', $upsellProduct).text('').removeClass('sale').addClass('hide');
            $('.product_price', $upsellProduct).text(''); 
            $('.cart-btn', $upsellProduct).removeClass('free-shipping').addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
            $('.shopify-payment-button', $upsellProduct).hide();

            }  
            
            //ecomTheme.geoIP(); 
            };
            var upsellProductPage = {
            init: function(){     
              $(".product-upsell .product_form_options").each(function() {
                new Shopify.OptionSelectors($(this).data("select-id"), { 
                  product: $(this).data("product"),
                  onVariantSelected: upsellSelectCallback, 
                  enableHistoryState: $(this).data("enable-state") 
                });
              }); 

            }
            }
          /**Toggle**/
          var ecom_toggle = {
            createAccordion: function(container, tab, content){
              var $container = $(container);
              var $tab = $(container).find(tab);
              var $content = $(container).find(content);
              var specificTab = container + ' ' + tab;

              //Check to see if need to rearrange product tabs to create accordion (backwards compatible)
              if (container.indexOf(".accordion-tabs") >= 0){
                var rearrangedTabs = $.map($tab, function(v, i) { return [v, $content[i]]; });
                $container.empty();

                $.each(rearrangedTabs, function (index, value) {
                  $container.append(this);
                });

                $content.removeClass('active');
                $container.find('.active').next().slideToggle();

                tab = container + '> a';
              }

              $(container).children('a').each(function(i, tab) {
                var tab = $(this);
                var tabValue = tab.attr('href'); //get tab id
                tab.attr('data-tab-value', tabValue); //set tab id in data attribute
                tab.removeAttr("href"); //remove href (to prevent url hash update)
              });

              $(container).find(tab + '.active').next().slideToggle();
              $('body').on('click', specificTab, function(e){
                e.preventDefault();
                $(this).toggleClass('active');
                $(this).next().slideToggle();
              });
            }
          }
          /**Product Tab**/
          var product_page_tabs = {
            init: function(){
              $('#horizontalTab').easyResponsiveTabs({
                type: 'default', //Types: default, vertical, accordion           
                width: 'auto', //auto or any width like 600px
                fit: true,   // 100% fit in a container
                closed: 'accordion', // Start closed if in accordion view
                activate: function(event) { // Callback function if tab is switched
                  var $tab = $(this);
                  var $info = $('#tabInfo');
                  var $name = $('span', $info);
                  $name.text($tab.text());
                  $info.show();
                }
              });
            }
          }
/*============================================================================
  Recently Viewed
==============================================================================*/
 
  var arrowSize = {
    x0: 10,
    x1: 60, y1: 50,
    x2: 70, y2: 40,
    x3: 30
  } 
var recentlyViewed = {
  init: function(){
    var productHandle,
        rvCookie,
        rvProducts,
        displayProducts,
        rvProductArray;

    if ($('.js_product_section[data-rv-handle]').length){
      productHandle = $('.js_product_section').data('rv-handle').toString();
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.recently-viewed__section').length){
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    } else if ($('.collection-template-section .js-sidebar-recently-viewed').length){
      rvCookie = Cookies.get('recentlyViewed');
      rvProducts = recentlyViewed.getCookieProducts(rvCookie, productHandle);
    }

    if (rvProducts){
      rvProductArray = unescape(rvProducts).split(',');
    } 
    if (productHandle){ 
      if(!$.inArray(productHandle, rvProductArray) !== -1){
        displayProducts = [];
        rvProductArray.unshift(productHandle);
        $.each(rvProductArray, function(i, el){
            if($.inArray(el, displayProducts) === -1) displayProducts.push(el);
        });
      }

      recentlyViewed.setCookieProducts(displayProducts);
    } else {
      displayProducts = rvProductArray;
    }

    if ($('.recently-viewed__section').length){
      var parent = '.recently-viewed__section';
      recentlyViewed.getProductInformation(parent, displayProducts);
    } else if ($('.js-recently-viewed .rv-main').length){
      var parent = '.js-recently-viewed';
      recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
    }

    if ($('.sidebar .js-sidebar-recently-viewed').length){
      var parent = '.sidebar .js-sidebar-recently-viewed';
      if (productHandle){
        recentlyViewed.getProductInformation(parent, displayProducts, productHandle);
      } else {
        recentlyViewed.getProductInformation(parent, displayProducts);
      }
      $('.js-sidebar-recently-viewed.hidden').parents('.sidebar-block').hide();
    }

  },
  getCookieProducts: function(rvCookie, productHandle){ 
   
    if (!rvCookie && productHandle) {
      Cookies.set('recentlyViewed', productHandle, { expires: 30, path: '/' });
      rvCookie = Cookies.get('recentlyViewed');
    } else {
      rvCookie = Cookies.get('recentlyViewed');
    }

    return rvCookie;

  },
  setCookieProducts: function(rvProductArray){
    Cookies.set('recentlyViewed', escape(rvProductArray.join(',')), { expires: 30, path: '/' }); 
  },
  getProductInformation: function(parent, displayProducts, productHandle){  
    if (productHandle){
      displayProducts.splice( $.inArray(productHandle, displayProducts), 1 );
    }

    var productLimit = $(parent).data('visible-products');

    if (productLimit && displayProducts){
      displayProducts = displayProducts.slice(0, productLimit);
    }

    $.each(displayProducts, function (index, value) {

      if (value){
        $(parent).removeClass('hidden');

        $(parent).parents('.sidebar-block').show();

        $.ajax({
          type: 'GET',
          url: '/products/' + value  + '?view=rv',
          success: function(data) {

            var rvProduct = $(data).find('.js-recently-viewed-product');
            

            $(parent).find(' .rv-box-' + index ).append(rvProduct);

             

           },
           error: function(x, t, m) {
            console.log(x);
            console.log(t);
            console.log(m);
           },
           dataType: "html"
        });
      }

      if ($(parent).find('.rv-main').hasClass('js-rv-slider')){
        if (displayProducts.length <= productLimit) {
          $('.js-rv-slider .gallery-cell').eq(displayProducts.length).nextAll().addBack().remove();
        } else {
          $('.js-rv-slider .gallery-cell').eq(productLimit).nextAll().addBack().remove();
        }
        recentlyViewed.createSlider(parent, productLimit);
      } else if ($(parent).find('.rv-main').hasClass('js-rv-grid')){
        if (displayProducts.length <= productLimit) {
          $('.js-rv-grid .thumbnail').eq(displayProducts.length).nextAll().addBack().remove();
        } else {
          $('.js-rv-grid .thumbnail').eq(productLimit).nextAll().addBack().remove();
        }
      }
    });
  },

  createSlider: function(el, productsAvailable){

    var products_per_slide = $('.js-rv-slider').data('products-per-slide');
    var products_limit = $('.js-rv-slider').data('products-limit');
    var products_available = productsAvailable;
    var indexProductsAvailable = productsAvailable - 1;
    var rvProductstoShow = $('.js-rv-slider').find('.gallery-cell');
    var cellAlign,
        draggable,
        prevNext,
        wrapAround,
        initialIndex;

    if (products_per_slide == "2" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "4" && products_available > products_per_slide && products_limit > products_per_slide || products_per_slide == "6" && products_available > products_per_slide && products_limit > products_per_slide){
      cellAlign = "left";
    } else {
      cellAlign = "center";
    }

    if (products_available > products_per_slide && products_limit > products_per_slide) {
      draggable = true;
      prevNext = true;
      wrapAround = true;
    } else {
      draggable = false;
      prevNext = false;
      wrapAround = false;
    }

    if (products_per_slide == "2" && products_available > products_per_slide || products_per_slide == "4" && products_available > products_per_slide || products_per_slide == "6" && products_available > products_per_slide){
      initialIndex = 0;
    } else if (products_per_slide == "3" && products_available) {
      initialIndex = 1;
    } else if (products_per_slide == "5" && products_available) {
      initialIndex = 2;
    } else if (products_per_slide == "7" && products_available) {
      initialIndex = 3;
    }

    if ($(window).width() <= 798) {

      cellAlign = "center";
      initialIndex = 1;

      if (rvProductstoShow.length <= 2){
        draggable = false;
        prevNext = false;
        wrapAround = false;
      } else if (products_available > 3 && products_limit > 3) {
        draggable = true;
        prevNext = true;
        wrapAround = true;
      } else {
        draggable = false;
        prevNext = false;
        wrapAround = false;
      }

      $('.js-rv-slider').parents('.even-num-slides').removeClass('even-num-slides');
    }

    /*$('.js-rv-sliders').flickity({
      "lazyLoad": 2,
      "imagesLoaded": true,
      "draggable": draggable,
      "prevNextButtons": prevNext,
      "wrapAround": wrapAround,
      "cellAlign": cellAlign,
      "pageDots": false,
      "contain": true,
      "freeScroll": true,
      "arrowShape": arrowSize,
      "initialIndex": initialIndex
    });*/
    $('.js-rv-slider').owlCarousel({
      nav : prevNext,
      dots: false,
      navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],
      items : products_per_slide, 
      responsive:{
        0:{
          items:2
        },
        600:{
          items:3
        },
        1000:{
          items:products_per_slide
        }
      }
    });

    $('.js-rv-slider').addClass('slider-initialized');
  }
}

          //document ready
          $(function() {            
            ecomtimer.init();
            progress_bar.init();
            recentlyViewed.init();
            // $("#progress_bar").progressbar();  
            // $("#progress_bar_2").progressbar();  
            // $("#progress_bar_3").progressbar();  
            $('.lightbox').fancybox();
            ecom_slideshow.init(); 
            product_page_tabs.init(); 
            gdpr.init();
            ecom_cart_timer.init();
            flashQTYSold.init();
            ecom_faqAccordion.init(); 
            ecom_visitor_count.init();
            ecom_featured_collection.init(); 
            
            

            
            ecomhope_InfiniteScroll();
             
            

            
            productPage.init();
            upsellProductPage.init();  
            function ajaxSubmitCart(cart) {
              $cart = cart;
              $.ajax({
                url: '/cart/update.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: $cart.serialize(),
                success: function (data) {
                  refreshCart(data);
                }
              });
            }

            function ajaxUpdateCart(lineID, quantity, parent) {
              $.ajax({
                url: '/cart/change.js',
                dataType: 'json',
                cache: false,
                type: 'post',
                data: { quantity: quantity, line: lineID },
                success: function (data) {
                  refreshCart(data);

                  var lineIDIndex = lineID - 1;

                  //check to see if there are correct amount of products in array
                  if (typeof data.items[lineIDIndex] === "undefined"){
                    var updated_quantity = 0;
                  } else {
                    var updated_quantity = data.items[lineIDIndex].quantity;
                  }

                  if(quantity > 0 && quantity != updated_quantity) {
                    if (updated_quantity == 1) {
                      items_left_text = "item left";
                    } else {
                      items_left_text = "items left";
                    }

                    $('.warning--quantity').remove();

                    var warning = '<p class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</p>';
                    parent.find("input[data-line-id='" + lineID + "']").parent().after(warning);
                    parent.find("input[data-line-id='" + lineID + "']").val(updated_quantity);
                  } else if (parent.is('#cart_form')) {
                    $("#cart_form").submit();
                  }
                }
              });
            }

            function refreshCart(cart) {
              $(".cart-count, .cart--count").empty();
              var $cartBtn = $(".cart-count, .cart--count");
              var value = $cartBtn.text() || '0';
              var cart_items_html = "";
              var cart_action_html = "";
              var cart_savings_html = "";
              var $cart = $(".cart_content form");
              var discounted_price_total = 0;
              var total_savings = 0;
              var shipping_savings = 5000;
              var save10 = 10000;
              var save20 = 15000;
              var continue_step = 'two';
              var total_price = cart.total_price;

              $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

              if (cart.item_count == 0) {
                $('.js-empty-cart__message').removeClass('hidden');
                $('.js-cart__message').addClass('hidden');
                $('.js-cart_content__form').addClass('hidden');
              } else {
                $('.js-empty-cart__message').addClass('hidden');
                $('.js-cart__message').removeClass('hidden');
                $('.js-cart_content__form').removeClass('hidden');

                $.each(cart.items, function(index, item) {
                  var line_id = index + 1;
                  cart_items_html += '<li class="cart_item clearfix"  data-title="' + item.handle +'">' +
                    '<a href="' + item.url +'">';
                  if (item.image) {
                    cart_items_html += '<div class="cart_image">' +
                      '<img src="' + item.image.replace(/(\.[^.]*)$/, "_compact$1").replace('http:', '') + '" alt="' + htmlEncode(item.title) + '" />' +
                      '</div>';
                  }

                  cart_items_html += '<strong class="right price">';

                  
                  $.ajax({
                    dataType: "json",
                    async: false,
                    cache: false,
                    url: "/products/" + item.handle + ".js",
                    success: function(data) {
                      var variant_id = item.variant_id;
                      var variant = $.grep(data.variants, function(v) {
                        return v.id == variant_id;
                      });

                      if(variant[0] && variant[0].compare_at_price > item.price) {
                        cart_items_html += ' <span class="money was_price">' + Shopify.formatMoney(variant[0].compare_at_price, $('body').data('money-format')) + '</span> ';
                        discounted_price_total += item.price * item.quantity;
                        total_savings += variant[0].compare_at_price * item.quantity;
                      }
                    }
                  });
                  

                  cart_items_html += '<span class="money">' + Shopify.formatMoney(item.price, $('body').data('money-format')) + '</span></strong>' + '<div class="item_title">' + item.title;

                  if(item.properties) {
                    $.each(item.properties, function(title, value) {
                      if (value) {
                        cart_items_html += '<div class="line-item">' + title +': ' + value + '</div>';
                      }
                    });
                  }

                  cart_items_html += '</div></a>';

                  cart_items_html += '<div class="left product-quantity-box">' +
                    '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="fa fa-minus"></span></span>' +
                    '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity +'" data-line-id="' + line_id +'" />' +
                    '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="fa fa-plus"></span></span>' +
                    '</div>' +
                    '</li>';


                });

                cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format')) + '</span></span>' +
                  '<span>Subtotal</span>';

                if(total_savings > 0 ) {
                  cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(total_savings - discounted_price_total, $('body').data('money-format')) + '</span></span>' +
                    '<span>Total Savings</span>';
                } else {
                  cart_savings_html = "";
                }
              }
              if(continue_step == 'two') {
                if(total_price > save20) {
                  $('.mobile-talkable-hide-on-mobile').html('FREE SHIPPING! AND 30% Coupon Code SAVE30');

                                                            } else if(save20 > save10 && total_price > save10 ) {
                    /**save20**/
                    var abc='<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-yes.png?v=157913204395306948691785934667" alt="">FREE SHIPPING! AND 20% Coupon Code SAVE20 </span> '+
                    '<span class="newline">'+
                      '<img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-no.png?v=130719664674677932441785934667" alt="">ONLY '+ 
                      '<span class="needmore">US <span class="money">'+Shopify.formatMoney(save20 - total_price, $('body').data('money-format'))+'</span></span> '+ 
                        'AWAY FROM A 30% DISCOUNT</span>';
                      $('.mobile-talkable-hide-on-mobile').html(abc);

                  } else if( save10 > shipping_savings && total_price > shipping_savings) {
                    /**save10**/
                    var abc='<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-yes.png?v=157913204395306948691785934667" alt="">FREE SHIPPING</span> '+
                    '<span class="newline">'+
                      '<img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-no.png?v=130719664674677932441785934667" alt="">ONLY '+
                      '<span class="needmore">US <span class="money">'+Shopify.formatMoney(save10 - total_price, $('body').data('money-format'))+'</span></span>'+ 
                        'AWAY FROM A 20% DISCOUNT</span>  ';
                      $('.mobile-talkable-hide-on-mobile').html(abc);
                  } else {

                    if(total_price == 0) { 
                      $('.mobile-talkable-hide-on-mobile').html('<span>ORDERS OVER '+Shopify.formatMoney(shipping_savings, $('body').data('money-format'))+' SHIP FREE!</span>');
                    } else if(total_price >= shipping_savings) {
                      $('.mobile-talkable-hide-on-mobile').html('<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-yes.png?v=157913204395306948691785934667" alt="">FREE SHIPPING </span>');
                                                                } else { 
                                                                $('.mobile-talkable-hide-on-mobile').html('<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-no.png?v=130719664674677932441785934667" alt="">ONLY <span class="needmore"><span class="money">'+Shopify.formatMoney(shipping_savings - total_price, $('body').data('money-format'))+'</span></span> AWAY FROM FREE SHIPPING</span>');                
                                                                                                          }  
                                                                                                          }

                                                                                                          }
                                                                                                          if(continue_step == 'one') {
                        if(total_price > save10) {
                          $('.mobile-talkable-hide-on-mobile').html('FREE SHIPPING! AND 20% Coupon Code SAVE20');

                                                                    } else if( save10 > shipping_savings && total_price > shipping_savings) {
                            /**save10**/
                            var abc='<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-yes.png?v=157913204395306948691785934667" alt="">FREE SHIPPING</span> '+
                            '<span class="newline">'+
                              '<img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-no.png?v=130719664674677932441785934667" alt="">ONLY '+
                              '<span class="needmore">US <span class="money">'+Shopify.formatMoney(save10 - total_price, $('body').data('money-format'))+'</span></span>'+ 
                                'AWAY FROM A 20% DISCOUNT</span>  ';
                              $('.mobile-talkable-hide-on-mobile').html(abc);
                          } else {

                            if(total_price == 0) { 
                               $('.mobile-talkable-hide-on-mobile').html('<span>ORDERS OVER '+Shopify.formatMoney(shipping_savings, $('body').data('money-format'))+' SHIP FREE!</span>');
                            } else if(total_price >= shipping_savings) {
                              $('.mobile-talkable-hide-on-mobile').html('<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-yes.png?v=157913204395306948691785934667" alt="">FREE SHIPPING </span>');
                                                                        } else { 
                                                                        $('.mobile-talkable-hide-on-mobile').html('<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-no.png?v=130719664674677932441785934667" alt="">ONLY <span class="needmore"><span class="money">'+Shopify.formatMoney(shipping_savings - total_price, $('body').data('money-format'))+'</span></span> AWAY FROM FREE SHIPPING</span>');                
                                                                                                                  }  
                                                                                                                  }
                                                                                                                  }
                                                                                                                  if(continue_step == 'none') {
                                if(total_price == 0) { 
        $('.mobile-talkable-hide-on-mobile').html('<span>ORDERS OVER '+Shopify.formatMoney(shipping_savings, $('body').data('money-format'))+' SHIP FREE!</span>');
                                } else if(total_price >= shipping_savings) {
                                  $('.mobile-talkable-hide-on-mobile').html('<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-yes.png?v=157913204395306948691785934667" alt="">FREE SHIPPING </span>');
                       } else { 
                       $('.mobile-talkable-hide-on-mobile').html('<span><img src="//siajewellaryhub.in/cdn/shop/t/3/assets/icon-no.png?v=130719664674677932441785934667" alt="">ONLY <span class="needmore"><span class="money">'+Shopify.formatMoney(shipping_savings - total_price, $('body').data('money-format'))+'</span></span> AWAY FROM FREE SHIPPING</span>');                
                } 
            }
         $('.js-cart_items').html(cart_items_html);
                                  $('.js-cart_subtotal').html(cart_action_html);
                                  $('.js-cart_savings').html(cart_savings_html);

                                  
                                }
                                $('body').on('click', '.js-change-quantity', function() {
                                  var $this = $(this),
                                      $input = $(this).siblings('input'),
                                      val = parseInt($input.val()),
                                      valMax = 100000000000000000000000000000,
                                      valMin = $input.attr('min') || 0;

                                  if ($input.attr('max') != null){
                                    valMax = $input.attr('max');
                                  }

                                  if(isNaN(val) || val < valMin) {
                                    $input.val(valMin);
                                    return false;
                                  } else if (val > valMax) {
                                    $input.val(valMax);
                                    return false;
                                  }

                                  if($this.data('func') == 'plus') {
                                    if(val < valMax) $input.val(val + 1);
                                  } else {
                                    if(val > valMin) $input.val(val - 1);
                                    if($this.parents(".cart_item").length) {
                                      if (val - 1 == 0) {
                                        $this.closest('.cart_item').addClass('animated fadeOutUp')
                                      }
                                    }
                                  }
                                  $input.trigger('change');

                                });
                                $('body').on("change", "#cart_form input.quantity", function() {
                                  ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('#cart_form'));
                                });

                                $('body').on("change", ".cart_content input.quantity", function() {
                                  ajaxUpdateCart($(this).data('line-id'), $(this).val(), $(this).parents('.cart_content'));
                                });

                                // Funnel Style 1
                                //Funnel Product Click Button 1
                                $('#product-page-funnel-3-A-template,#product-page-funnel-3-B-template,#product-page-funnel-3-C-template,#product-page-funnel-3-D-template,#product-page-funnel-3-E-template,#product-page-funnel-3-F-template,#product-page-funnel-3-G-template,#product-page-funnel-3-H-template').on('click',function(e) { 
                                  e.preventDefault();
                                  var $addToCartForm = $(".page-funnel--section-1 .product_form form");
                                  var $productID = $addToCartForm.attr('data-product-id');
                                  var $addToCartBtn = $(this);        
                                  $.ajax({
                                    url: '/cart/add.js',
                                    dataType: 'json',
                                    cache: false,
                                    type: 'post',
                                    data: $addToCartForm.serialize(),
                                    beforeSend: function() {
                                      $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                      $addToCartBtn.find('span').html('Adding...');
                                                                      },
                                                                      success: function(itemData) {
                                        $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                        $addToCartBtn.find('span').html('Thank You'); 
                                                                        window.setTimeout(function(){  
                                          $addToCartBtn.find('span').html($addToCartBtn.data('label')); 
                                          location.href="/checkout";
                                        }, 1000);
                                        return false; 
                                      },
                                        error: function(XMLHttpRequest) {
                                        }
                                    });      
                                    return false; 
                                  });
                                  //Product Button 2
                                  $('.buy-now-btn').on('click',function(e) {
                                    e.preventDefault();
                                    var $addToCartForm = $('.product_form form');
                                    var $productID = $addToCartForm.attr('data-product-id');
                                    var $addToCartBtn = $addToCartForm.find('.buy-now-btn');    
                                    $.ajax({
                                      url: '/cart/add.js',
                                      dataType: 'json',
                                      cache: false,
                                      type: 'post',
                                      data: $addToCartForm.serialize(),
                                      beforeSend: function() {
                                        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                      },
                                      success: function(itemData) {
                                        $addToCartBtn.removeAttr('disabled').removeClass('disabled');           
                                        window.setTimeout(function(){    
                                          location.href="/checkout";
                                        }, 1000);
                                        return false; 
                                      },
                                      error: function(XMLHttpRequest) {
                                      }
                                    });      
                                    return false; 
                                  });
                                  // Funnel Style 1
                                  //Funnel Product Click Button 1
                                  $('#product-page-funnel-template').on('click',function(e) { 
                                    e.preventDefault();
                                    var $addToCartForm = $(".page-funnel--section-1 .product_form form");
                                    var $productID = $addToCartForm.attr('data-product-id');
                                    var $addToCartBtn = $(this);    
                                    var $addToCartBtns = $('.funnel-show-1 #product-page-funnel-template');    
                                    $.ajax({
                                      url: '/cart/add.js',
                                      dataType: 'json',
                                      cache: false,
                                      type: 'post',
                                      data: $addToCartForm.serialize(),
                                      beforeSend: function() {
                                        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                        $addToCartBtn.find('span').html('Adding...');
                                                                        $addToCartBtns.attr('disabled', 'disabled').addClass('disabled');
                                        $addToCartBtns.find('span').html('Adding...');
                                                                         },
                                                                         success: function(itemData) {
                                          $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                          $addToCartBtn.find('span').html('Thank You');
                                                                          $addToCartBtns.removeAttr('disabled').removeClass('disabled');     
                                          $addToCartBtns.find('span').html('Thank You');
                                                                           window.setTimeout(function(){  
                                            $addToCartBtn.find('span').html($addToCartBtn.data('label'));
                                            $addToCartBtns.find('span').html($addToCartBtn.data('label'));
                                            makeSearch();
                                            
                                            $('.funnel-show-1').hide();
                                            $('.funnel-show-2').show();     
                                            
                                          }, 1000);
                                          return false; 
                                        },
                                          error: function(XMLHttpRequest) {
                                          }
                                      });      
                                      return false; 
                                    });
                                    //Funnel Product Click Button 2
                                    $('#product-page-funnel-2-template').on('click',function(e) { 
                                      e.preventDefault();
                                      var $addToCartForm = $(".page-funnel--section-2 .product_form form");
                                      var $productID = $addToCartForm.attr('data-product-id');
                                      var $addToCartBtn = $(this);    
                                      var $addToCartBtns = $('.funnel-show-2 #product-page-funnel-2-template');    
                                      $.ajax({
                                        url: '/cart/add.js',
                                        dataType: 'json',
                                        cache: false,
                                        type: 'post',
                                        data: $addToCartForm.serialize(),
                                        beforeSend: function() {
                                          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                          $addToCartBtn.find('span').html('Adding...');
                                                                          $addToCartBtns.attr('disabled', 'disabled').addClass('disabled');
                                          $addToCartBtns.find('span').html('Adding...');
                                                                           },
                                                                           success: function(itemData) {
                                            $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                            $addToCartBtn.find('span').html('Thank You');
                                                                            $addToCartBtns.removeAttr('disabled').removeClass('disabled');     
                                            $addToCartBtns.find('span').html('Thank You');
                                                                             window.setTimeout(function(){  
                                              $addToCartBtn.find('span').html($addToCartBtn.data('label'));
                                              $addToCartBtns.find('span').html($addToCartBtn.data('label'));
                                              makeSearch();
                                              
                                              $('.funnel-show-1').hide();
                                              $('.funnel-show-2').hide(); 
                                              $('.funnel-show-3').show();                          
                                              
                                            }, 1000);
                                            return false; 
                                          },
                                            error: function(XMLHttpRequest) {
                                            }
                                        });      
                                        return false; 
                                      });
                                      //Funnel Product Click Button 3
                                      $('#product-page-funnel-3-template').on('click',function(e) { 
                                        e.preventDefault();
                                        var $addToCartForm = $(".page-funnel--section-3 .product_form form");
                                        var $productID = $addToCartForm.attr('data-product-id');
                                        var $addToCartBtn = $(this);    
                                        var $addToCartBtns = $('.funnel-show-3 #product-page-funnel-3-template');    
                                        $.ajax({
                                          url: '/cart/add.js',
                                          dataType: 'json',
                                          cache: false,
                                          type: 'post',
                                          data: $addToCartForm.serialize(),
                                          beforeSend: function() {
                                            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                            $addToCartBtn.find('span').html('Adding...');
                                                                            $addToCartBtns.attr('disabled', 'disabled').addClass('disabled');
                                            $addToCartBtns.find('span').html('Adding...');
                                                                             },
                                                                             success: function(itemData) {
                                              $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                              $addToCartBtn.find('span').html('Thank You');
                                                                              $addToCartBtns.removeAttr('disabled').removeClass('disabled');     
                                              $addToCartBtns.find('span').html('Thank You');
                                                                               window.setTimeout(function(){  
                                                $addToCartBtn.find('span').html($addToCartBtn.data('label'));
                                                $addToCartBtns.find('span').html($addToCartBtn.data('label'));
                                                $('.checkout-btn').click();
                                              }, 1000);
                                              return false; 
                                            },
                                              error: function(XMLHttpRequest) {
                                              }
                                          });      
                                          return false; 
                                        });

                                        // Funnel Style 2
                                        //Funnel Product Click Button 1
                                        $('#product-page-funnel-2-template-1').on('click',function(e) { 
                                          e.preventDefault();
                                          var $addToCartForm = $(".page-funnel--section-1 .product_form form");
                                          var $productID = $addToCartForm.attr('data-product-id');
                                          var $addToCartBtn = $(this);  
                                          var $addToCartBtns = $('.funnel-show-1 #product-page-funnel-2-template-1');    
                                          $.ajax({
                                            url: '/cart/add.js',
                                            dataType: 'json',
                                            cache: false,
                                            type: 'post',
                                            data: $addToCartForm.serialize(),
                                            beforeSend: function() {
                                              $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                              $addToCartBtn.find('span').html('Adding...');
                                                                              $addToCartBtns.attr('disabled', 'disabled').addClass('disabled');
                                              $addToCartBtns.find('span').html('Adding...');
                                                                               },
                                                                               success: function(itemData) {
                                                $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                                $addToCartBtn.find('span').html('Thank You');
                                                                                $addToCartBtns.removeAttr('disabled').removeClass('disabled');     
                                                $addToCartBtns.find('span').html('Thank You');
                                                                                 window.setTimeout(function(){  
                                                  $addToCartBtn.find('span').html($addToCartBtn.data('label'));
                                                  $addToCartBtns.find('span').html($addToCartBtn.data('label'));
                                                  makeSearch();
                                                  
                                                  $('.funnel-show-1').hide();
                                                  $('.funnel-show-2').show();     
                                                  
                                                }, 1000);
                                                return false; 
                                              },
                                                error: function(XMLHttpRequest) {
                                                }
                                            });      
                                            return false; 
                                          });
                                          //Funnel Product Click Button 2
                                          $('#product-page-funnel-2-template-2').on('click',function(e) { 
                                            e.preventDefault();
                                            var $addToCartForm = $(".page-funnel--section-2 .product_form form");
                                            var $productID = $addToCartForm.attr('data-product-id');
                                            var $addToCartBtn = $(this);    
                                            var $addToCartBtns = $('.funnel-show-2 #product-page-funnel-2-template-2');    
                                            $.ajax({
                                              url: '/cart/add.js',
                                              dataType: 'json',
                                              cache: false,
                                              type: 'post',
                                              data: $addToCartForm.serialize(),
                                              beforeSend: function() {
                                                $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                                $addToCartBtn.find('span').html('Adding...');
                                                                                $addToCartBtns.attr('disabled', 'disabled').addClass('disabled');
                                                $addToCartBtns.find('span').html('Adding...');
                                                                                 },
                                                                                 success: function(itemData) {
                                                  $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                                  $addToCartBtn.find('span').html('Thank You');
                                                                                  $addToCartBtns.removeAttr('disabled').removeClass('disabled');     
                                                  $addToCartBtns.find('span').html('Thank You');
                                                                                   window.setTimeout(function(){  
                                                    $addToCartBtn.find('span').html($addToCartBtn.data('label'));
                                                    $addToCartBtns.find('span').html($addToCartBtn.data('label'));
                                                    makeSearch();
                                                    
                                                    $('.funnel-show-1').hide();
                                                    $('.funnel-show-2').hide(); 
                                                    $('.funnel-show-3').show();                          
                                                    
                                                  }, 1000);
                                                  return false; 
                                                },
                                                  error: function(XMLHttpRequest) {
                                                  }
                                              });      
                                              return false; 
                                            });
                                            //Funnel Product Click Button 3
                                            $('#product-page-funnel-2-template-3').on('click',function(e) { 
                                              e.preventDefault();
                                              var $addToCartForm = $(".page-funnel--section-3 .product_form form");
                                              var $productID = $addToCartForm.attr('data-product-id');
                                              var $addToCartBtn = $(this);    
                                              var $addToCartBtns = $('.funnel-show-3 #product-page-funnel-2-template-3');    
                                              $.ajax({
                                                url: '/cart/add.js',
                                                dataType: 'json',
                                                cache: false,
                                                type: 'post',
                                                data: $addToCartForm.serialize(),
                                                beforeSend: function() {
                                                  $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                                  $addToCartBtn.find('span').html('Adding...');
                                                                                  $addToCartBtns.attr('disabled', 'disabled').addClass('disabled');
                                                  $addToCartBtns.find('span').html('Adding...');
                                                                                   },
                                                                                   success: function(itemData) {
                                                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                                    $addToCartBtn.find('span').html('Thank You');
                                                                                    $addToCartBtns.removeAttr('disabled').removeClass('disabled');     
                                                    $addToCartBtns.find('span').html('Thank You');
                                                                                     window.setTimeout(function(){  
                                                      $addToCartBtn.find('span').html($addToCartBtn.data('label'));
                                                      $addToCartBtns.find('span').html($addToCartBtn.data('label'));
                                                      $('.checkout-btn').click();
                                                    }, 1000);
                                                    return false; 
                                                  },
                                                    error: function(XMLHttpRequest) {
                                                    }
                                                });      
                                                return false; 
                                              });


                                              $('#funnel-show-3').on('click',function(){
                                                $('.funnel-show-3').show(); 
                                                $('.funnel-show-2').hide(); 
                                                makeSearch();
                                                return false;
                                              })
                                              function makeSearch(){ 
                                                $("html, body").animate({
                                                  scrollTop: 0
                                                }, 800);

                                              }
                                              $('#formpreventcart').on('submit', function(e) {
                                                e.preventDefault();
                                              });
                                              
                                            //Funnel Product Click Button 3
                                            $('#bottom-bar-button').on('click',function(e) { 
                                              e.preventDefault();
                                              var $addToCartForm = $(".product-bottom-bar .product_form form");
                                              var $productID = $addToCartForm.attr('data-product-id');
                                              var $addToCartBtn = $(this);         
                                              $.ajax({
                                                url: '/cart/add.js',
                                                dataType: 'json',
                                                cache: false,
                                                type: 'post',
                                                data: $addToCartForm.serialize(),
                                                beforeSend: function() {
                                                  $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                                  $addToCartBtn.find('span').html('Adding...'); 
                                                                                   },
                                                                                   success: function(itemData) {
                                                    $addToCartBtn.removeAttr('disabled').removeClass('disabled');     
                                                    $addToCartBtn.find('span').html('Thank You'); 
                                                                                     window.setTimeout(function(){  
                                                      $addToCartBtn.find('span').html($addToCartBtn.data('label')); 
                                                      $('.product-bottom-bar').hide();
                                                                                                                               
                                                              $('li.cart .cd-cart-trigger').trigger('click');                                       
                                                               
                                                    }, 1000);
                                                    return false; 
                                                  },
                                                    error: function(XMLHttpRequest) {
                                                    }
                                                });      
                                                return false; 
                                              }); 
                                              $('body').on('submit', ".product_form form", function(e) {
                                                e.preventDefault();

                                                var $addToCartForm = $(this);

                                                var $productID = $addToCartForm.attr('data-product-id');
                                                var $addToCartBtn = $addToCartForm.find('.cart-btn');   

                                                $.ajax({
                                                  url: '/cart/add.js',
                                                  dataType: 'json',
                                                  cache: false,
                                                  type: 'post',
                                                  data: $addToCartForm.serialize(),
                                                  beforeSend: function() {
                                                    $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                                    $addToCartBtn.find('span').text('Adding...');
                                                                                    },
                                                                                    success: function(itemData) {
                                                      $addToCartBtn.removeAttr('disabled').removeClass('disabled');       
                                                      $addToCartBtn.find('span').text('Thank You');

                                                                                      window.setTimeout(function(){
                                                        $addToCartBtn.find('span').text($addToCartBtn.data('label'));
                                                        var enable_usell = false;
                                                        $(".product-upsell-template .enable-product-upsell").each(function() {
                                                          var product_id = $(this).data("product-id");
                                                          if(product_id == $productID){ 
                                                            enable_usell = true;
                                                            //  var dd = $(this).find('.product-upsell-'+product_id).attr('href'); 
                                                            var $upsell_enable = $(this).find('.product-upsell-'+product_id);     
                                                            $upsell_enable.fancybox({
                                                              closeClick  : false, // prevents closing when clicking INSIDE fancybox 
                                                              openEffect  : 'none',
                                                              closeEffect : 'none',
                                                              wrapCSS : 'product-upsell-outer pp-'+product_id,
                                                              helpers   : { 
                                                                overlay : {closeClick: false} // prevents closing when clicking OUTSIDE fancybox 
                                                              }
                                                            }).trigger("click");
                                                            return false; 
                                                          }

                                                        });                                     
                                                        $.ajax({
                                                          url: '/cart.js',
                                                          dataType: "json",
                                                          cache: false,
                                                          success: function(cart) {  
                                                            refreshCart(cart); 
                                                            if($(".cart-value").val() == 1) { 
                                                              location.href="/cart"; 
                                                            }
                                                            if(enable_usell == false) {
                                                                                                                                       
                                                              $('li.cart .cd-cart-trigger').trigger('click');                                       
                                                               
                                                            }
                                                            var template = '<li class="item" id="cart-item-{ID}"><span title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></span><div class="product-details"><p class="product-name">{TITLE}</p><div class="product-half-details"><span class="half"><span class="cart-collateral">Sub Items: {QUANTITY}</span><span class="price">Subtotal: <span class="money">{PRICE}</span></span></span> <span class="half"><p><a href="/cart" class="cart_btns">View Cart</a></p><a href="/checkout" class="checkout_btn">Checkout</a></span></div></li>';
                                                            for (var i = 0; i < cart.items.length; i++) {
                                                              var item = template;
                                                              item = item.replace(/\{ID\}/g, cart.items[i].id);
                                                              item = item.replace(/\{URL\}/g, cart.items[i].url);
                                                              item = item.replace(/\{TITLE\}/g, cart.items[i].title);
                                                              item = item.replace(/\{QUANTITY\}/g, cart.item_count);
                                                              item = item.replace(/\{IMAGE\}/g, cart.items[i].image);
                                                              item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.total_price,  $('body').data('money-format')));
                                                              $('.cart-result .mini-cart').html(item); 
                                                              $(".product-upsell-outer #collection .featured-part .product_grid").each(function(index, element) {
                                                                var product_handle = $(this).data('product-handle');
                                                                if(cart.items[i].handle == product_handle) {
                                                                  $(this).hide();
                                                                }

                                                              });
                                                            }
                                                            var u_id = '#product-upsell-'+$productID+' #collection .featured-part .product_grid:visible';                 

                                                            if ($(u_id).length == 0) {
                                                              $('.upsell-heading').hide();
                                                            }
                                                            
                                                          }
                                                        });
                                                      }, 1000);
                                                    },
                                                      error: function(XMLHttpRequest) {


                                                      }
                                                  });  
                                                  return false; 
                                                });

                                                //Upsell Collection add
                                                $('body').on('submit', ".product-upsell-outer .collection-upsell-product .upsell_product_form form", function(e) {
                                                  e.preventDefault();
                                                  var $addToCartForm = $(this);
                                                  var $upsell_productID = $('.product-upsell-outer .collection-upsell-product').attr('data-product-upsell-id');
                                                  var $productID = $addToCartForm.attr('data-product-id');
                                                  var $addToCartBtn = $addToCartForm.find('.cart-btn');
                                                  var $upsell_enable = $('#product-upsell-'+$productID);    
                                                  var $product_form = $('#product-form-'+$productID);       

                                                  $.ajax({
                                                    url: '/cart/add.js',
                                                    dataType: 'json',
                                                    cache: false,
                                                    type: 'post',
                                                    data: $addToCartForm.serialize(),
                                                    beforeSend: function() {
                                                      $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                                    },
                                                    success: function(itemData) {
                                                      $addToCartBtn.find('.texts').html('Added');
                                                      window.setTimeout(function(){

                                                        $.ajax({
                                                          url: '/cart.js',
                                                          dataType: "json",
                                                          cache: false,
                                                          success: function(cart) {
                                                            refreshCart(cart); 
                                                            var template = '<li class="item" id="cart-item-{ID}"><span title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></span><div class="product-details"><p class="product-name">{TITLE}</p><div class="product-half-details"><span class="half"><span class="cart-collateral">Sub Items: {QUANTITY}</span><span class="price">Subtotal: <span class="money">{PRICE}</span></span></span> <span class="half"><p><a href="/cart" class="cart_btns">View Cart</a></p><a href="/checkout" class="checkout_btn">Checkout</a></span></div></li>';
                                                            for (var i = 0; i < cart.items.length; i++) {  
                                                              var item = template;
                                                              item = item.replace(/\{ID\}/g, cart.items[i].id);
                                                              item = item.replace(/\{URL\}/g, cart.items[i].url);
                                                              item = item.replace(/\{TITLE\}/g, cart.items[i].title);
                                                              item = item.replace(/\{QUANTITY\}/g, cart.item_count);
                                                              item = item.replace(/\{IMAGE\}/g, cart.items[i].image);
                                                              item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.total_price, $addToCartForm.data('money-format')));
                                                              $('.cart-result .mini-cart').html(item); 
                                                              $(".product-upsell-outer #collection .featured-part .product_grid").each(function(index, element) {
                                                                var product_handle = $(this).data('product-handle');
                                                                if(cart.items[i].handle == product_handle) {
                                                                  $(this).remove();
                                                                }
                                                              });    
                                                              var u_id = '#product-upsell-'+$upsell_productID+' #collection .featured-part .product_grid:visible';                 
                                                              // alert($(u_id).length);
                                                              if ($(u_id).length == 0) {
                                                                $('.upsell-heading').hide();
                                                              }
                                                              
                                                              return false;
                                                            }
                                                          }
                                                        });
                                                      }, 1000);
                                                    },
                                                    error: function(XMLHttpRequest) {
                                                    }
                                                  });  
                                                  return false; 
                                                });

                                                //Upsell Single Product add Style 1
                                                $('body').on('submit', ".product-upsell-outer .product_layout_upsell_1.single-upsell-product .upsell_product_form form", function(e) {
                                                  e.preventDefault();
                                                  var $addToCartForm = $(this); 
                                                  var $upsell_productID = $('.product-upsell-outer .single-upsell-product').attr('data-product-upsell-id');
                                                  var $productID = $addToCartForm.attr('data-product-id');
                                                  var $addToCartBtn = $addToCartForm.find('.cart-btn');
                                                  var $upsell_enable = $('#product-upsell-'+$productID);    
                                                  var $product_form = $('#product-form-'+$productID);       

                                                  $.ajax({
                                                    url: '/cart/add.js',
                                                    dataType: 'json',
                                                    cache: false,
                                                    type: 'post',
                                                    data: $addToCartForm.serialize(),
                                                    beforeSend: function() {
                                                      $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                                    },
                                                    success: function(itemData) {
                                                      $addToCartBtn.find('.texts').html('Added');
                                                      window.setTimeout(function(){
                                                        $addToCartBtn.removeAttr('disabled').removeClass('disabled');  
                                                      }, 1000);
                                                      $.ajax({
                                                        url: '/cart.js',
                                                        dataType: "json",
                                                        cache: false,
                                                        success: function(cart) {
                                                          refreshCart(cart); 

                                                          var template = '<li class="item" id="cart-item-{ID}"><span title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></span><div class="product-details"><p class="product-name">{TITLE}</p><div class="product-half-details"><span class="half"><span class="cart-collateral">Sub Items: {QUANTITY}</span><span class="price">Subtotal: <span class="money">{PRICE}</span></span></span> <span class="half"><p><a href="/cart" class="cart_btns">View Cart</a></p><a href="/checkout" class="checkout_btn">Checkout</a></span></div></li>';
                                                          for (var i = 0; i < cart.items.length; i++) {  
                                                            var item = template;
                                                            item = item.replace(/\{ID\}/g, cart.items[i].id);
                                                            item = item.replace(/\{URL\}/g, cart.items[i].url);
                                                            item = item.replace(/\{TITLE\}/g, cart.items[i].title);
                                                            item = item.replace(/\{QUANTITY\}/g, cart.item_count);
                                                            item = item.replace(/\{IMAGE\}/g, cart.items[i].image);
                                                            item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.total_price, $addToCartForm.data('money-format')));
                                                            $('.cart-result .mini-cart').html(item); 
                                                            $(".product-upsell-outer #collection .featured-part .product_grid").each(function(index, element) {
                                                              var product_handle = $(this).data('product-handle');
                                                              if(cart.items[i].handle == product_handle) {
                                                                // alert(cart.items[i].handle+' =='+ product_handle);
                                                                $(this).remove();
                                                              }else{
                                                                $(this).show();
                                                              }

                                                            });  
                                                            var u_id = '#product-upsell-'+$upsell_productID+' #collection .featured-part .product_grid:visible';                 

                                                            if ($(u_id).length == 0) {
                                                              $('.upsell-heading').hide();
                                                            }
                                                            
                                                            return false;
                                                          }


                                                        }
                                                      });
                                                    },
                                                    error: function(XMLHttpRequest) {
                                                    }
                                                  });  
                                                  return false; 
                                                });

                                                //Upsell Single Product add Style 2
                                                $('body').on('submit', ".product-upsell-outer .product_layout_upsell_2.single-upsell-product .upsell_product_form form", function(e) {
                                                  e.preventDefault();
                                                  var $addToCartForm = $(this); 
                                                  var $upsell_productID = $('.product-upsell-outer .single-upsell-product').attr('data-product-upsell-id');
                                                  var $productID = $addToCartForm.attr('data-product-id');
                                                  var $addToCartBtn = $addToCartForm.find('.cart-btn');
                                                  var $upsell_enable = $('#product-upsell-'+$productID);    
                                                  var $product_form = $('#product-form-'+$productID);       

                                                  $.ajax({
                                                    url: '/cart/add.js',
                                                    dataType: 'json',
                                                    cache: false,
                                                    type: 'post',
                                                    data: $addToCartForm.serialize(),
                                                    beforeSend: function() {
                                                      $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                                                    },
                                                    success: function(itemData) {
                                                      $addToCartBtn.find('.texts').html('Added');
                                                      window.setTimeout(function(){
                                                        $addToCartBtn.removeAttr('disabled').removeClass('disabled');  
                                                      }, 1000);
                                                      $.ajax({
                                                        url: '/cart.js',
                                                        dataType: "json",
                                                        cache: false,
                                                        success: function(cart) {
                                                          refreshCart(cart);   
                                                          $(".product-upsell-outer #collection .featured-part .product_grid").each(function(index, element) {
                                                            var show_second = $(this).data('show-second');
                                                            var product_handle = $(this).data('product-handle');
                                                            if(show_second == true){
                                                              $(this).remove();
                                                              $('.upsell_product_2_show').show();
                                                              return false;
                                                            }else{                            
                                                              location.href="/checkout";
                                                            } return false; 
                                                          }); 
                                                          
                                                          return false; 
                                                        }
                                                      });
                                                    },
                                                    error: function(XMLHttpRequest) {
                                                    }
                                                  });  
                                                  return false; 
                                                });

                                                $("#cart_form input[type='number']").change(function() {$("#cart_form").submit(); });
                                                $("#cart_form .fa").click(function() {$("#cart_form").submit(); });
                                                $('.video').video();     

                                                // Upsell Product Thumbnail
                                                $('.product-photo-thumbs').owlCarousel({nav:true,dots:false,navText:["<i class='fa fa-angle-left'></i>","<i class='fa fa-angle-right'></i>"],items:4,responsive:{0:{items:3},600:{items:3},900:{items:4}}});

                                                ecom_toggle.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
                                                //Sidebar toggle check
                                                if ($(window).width() <= 798) {
                                                  ecom_toggle.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
                                                } 
                                                //Homepage Video 
                                                $('.fancybox-video').magnificPopup({
                                                  type: 'iframe',
                                                  mainClass: 'mfp-fade',
                                                  removalDelay: 160,
                                                  preloader: false,

                                                  fixedContentPos: false
                                                }); 
                                                social.instagram();
                                                // if($(window).width()<640){$(".fancybox-video").fancybox({padding:0,margin:10,nextEffect:'fade',prevEffect:'none',width:'480px',height:'270px',aspectRatio:false})}else if($(window).width()<960){$(".fancybox-video").fancybox({padding:0,margin:10,nextEffect:'fade',prevEffect:'none',width:'720px',height:'405px',aspectRatio:false})}else if($(window).width()<1280){$(".fancybox-video").fancybox({padding:0,margin:10,nextEffect:'fade',prevEffect:'none',width:'960px',height:'540px',aspectRatio:false})}else if($(window).width()<1440){$(".fancybox-video").fancybox({padding:0,margin:10,nextEffect:'fade',prevEffect:'none',width:'1280px',height:'720px',aspectRatio:false})}else if($(window).width()<1920){$(".fancybox-video").fancybox({padding:0,margin:10,nextEffect:'fade',prevEffect:'none',width:'1440px',height:'810px',aspectRatio:false})}else{$(".fancybox-video").fancybox({padding:0,margin:10,nextEffect:'fade',prevEffect:'none',width:'1920px',height:'1080px',aspectRatio:false})}
                                                if($(window).width()<767){
                                                  $(".footer-menu h5").click(function(){
                                                    $(this).next().toggle();
                                                  });
                                                } 

                                                /**FBT**/
                                                function total_price() { 
                                                  var sale_price = 0;
                                                  var compare_price = 0;
                                                  var total_sale_price = 0;
                                                  var total_compare_price = 0;
                                                  $("ul.cbb-frequently-bought-selector-list li").each(function() { 
                                                    sale_price = parseInt($(this).find('.cbb-frequently-bought-selector-input:checked').attr("data-sale-price"));
                                                    compare_price = parseInt($(this).find('.cbb-frequently-bought-selector-input:checked').attr("data-compare-price"));
                                                    console.log(sale_price);
                                                    if(isNaN(sale_price)) {}else{
                                                      total_sale_price =total_sale_price + sale_price;
                                                    }
                                                    if(isNaN(compare_price)) {}else{
                                                      total_compare_price =total_compare_price + compare_price;
                                                    }
                                                  });   
                                                  $('.cbb-frequently-bought-total-price-price span').html(Shopify.formatMoney(total_sale_price,  $('body').data('money-format')));
                                                  $('.cbb-frequently-bought-total-price-was-price span').html(Shopify.formatMoney(total_compare_price,  $('body').data('money-format')));
                                                }
                                                $(document).on('change','.cbb-recommendations-variant-select',function() {
                                                  //  $(".cbb-recommendations-variant-select").change(function() {
                                                  var variantID = $('option:selected', this).val();
                                                  var sale_p = $('option:selected', this).data("sale-price");
                                                  var compare_p = $('option:selected', this).data("compare-price");  
                                                  $(this).parent().find('.variantID').val(variantID);
                                                  $(this).parent().find('.cbb-frequently-bought-selector-input').attr("data-sale-price",sale_p);
                                                  $(this).parent().find('.cbb-frequently-bought-selector-input').attr("data-compare-price",compare_p);
                                                  $(this).parent().find('.cbb-frequently-bought-selector-label-price').html(Shopify.formatMoney(sale_p,  $('body').data('money-format')));
                                                  $(this).parent().find('.cbb-frequently-bought-selector-label-compare-at-price').html(Shopify.formatMoney(compare_p,  $('body').data('money-format')));
                                                  total_price();
                                                });
                                                window.onload = function() {
                                                  total_price();
                                                }; 
                                                $(document).on('change','.cbb-frequently-bought-selector-input',function() { 
                                                  var product_id = $(this).parent().attr('data-product-id'); 
                                                  var total = $('ul.cbb-frequently-bought-products li').length;
                                                  var visibletotal = $('ul.cbb-frequently-bought-products li:visible').length; 
                                                  if (!$(this).is(':checked')) {
                                                    $(this).parent().css('opacity','0.5');
                                                    $(this).parent().find('.variantQuant').val(0);

                                                    $("ul.cbb-frequently-bought-products li").each(function(index) { 
                                                      var product_ids = $(this).attr('data-product-id');  
                                                      if(product_id == product_ids) {
                                                        $(this).hide();
                                                        if (index === visibletotal - 1) {
                                                          // this is the last one 
                                                          $(this).prev().find('.cbb-frequently-bought-plus-icon').hide();
                                                        }
                                                      } 

                                                    });  


                                                  } else {

                                                    $(this).parent().css('opacity','1');
                                                    $(this).parent().find('.variantQuant').val(1);
                                                    $("ul.cbb-frequently-bought-products li").each(function(index) { 
                                                      var product_ids = $(this).attr('data-product-id');  
                                                      if(product_id == product_ids) {
                                                        $(this).css("display","inline-block"); 
                                                        if (index === total - 1) {
                                                          // this is the last one 

                                                          $(this).prev().find('.cbb-frequently-bought-plus-icon').show();
                                                        }
                                                      }

                                                    });
                                                  }
                                                  $("ul.cbb-frequently-bought-products li:visible").each(function(index) { 
                                                    $(this).prevAll(':visible:first').find('.cbb-frequently-bought-plus-icon').show();
                                                    //$(this).prev().find('.cbb-frequently-bought-plus-icon').show();
                                                    $(this).find('.cbb-frequently-bought-plus-icon').hide();

                                                  });  

                                                  total_price();        
                                                });
                                                var length = $('ul.cbb-frequently-bought-products li').length; 
                                                $("#quantity-0").focus();    
                                                $("#submit-table").click(function(e) {     
                                                  e.preventDefault();
                                                  //array for Variant Titles
                                                  var toAdd = new Array();
                                                  var qty ;
                                                  for(i=0; i < length; i++){

                                                    toAdd.push({
                                                      variant_id: $("#variant-"+i).val(),        
                                                      quantity_id: $("#quantity-"+i).val() 
                                                    });
                                                  }
                                                  function moveAlong(){
                                                    if (toAdd.length) {
                                                      var request = toAdd.shift();
                                                      var tempId= request.variant_id;
                                                      var tempQty = request.quantity_id;
                                                      var params = {
                                                        type: 'POST',
                                                        url: '/cart/add.js',
                                                        data: 'quantity='+tempQty+'&id='+tempId,
                                                        dataType: 'json',
                                                        success: function(line_item) {                                                           
                                                          moveAlong();

                                                        },
                                                        error: function() {
                                                          moveAlong();

                                                        }
                                                      };
                                                      $.ajax(params);
                                                    }
                                                    else {	
                                                      $.ajax({
                                                        url: '/cart.js',
                                                        dataType: "json",
                                                        cache: false,
                                                        success: function(cart) {  
                                                          refreshCart(cart);   
                                                                                                                                   
                                                          $('li.cart .cd-cart-trigger').trigger('click');                                       
                                                            
                                                          
                                                        }
                                                      }); 
                                                    }  
                                                  };
                                                  moveAlong();
                                                });

                                              }); 


                                              $(document).on('shopify:section:load', function(e){
                                                var $parentSection = $('#shopify-section-' + e.detail.sectionId);
                                                 
                                                gdpr.init(); 
                                                if ($parentSection.hasClass('product-template')){              
                                                  ecomtimer.init();
                                                  progress_bar.init();  
                                                  productPage.init(); 
                                                  flashQTYSold.init();										
                                                  product_page_tabs.init(); 
                                                  ecom_visitor_count.init();
                                                  ecom_featured_collection.init();
                                                  recentlyViewed.init();
                                                }
               
                                                if ($parentSection.hasClass('featured-products-section')){                          
                                                  // ecomtimer.init();
                                                  progress_bar.init(); 
                                                  ecom_visitor_count.init();
                                                  productPage.init(); 
                                                }
                                                if ($parentSection.hasClass('product-upsell-template')){
                                                  upsellProductPage.init(); 
                                                }
                                                if ($parentSection.hasClass('cart-template')){            
                                                  // ecomtimer.init();
                                                  // progress_bar.init();               
                                                  ecom_cart_timer.init(); 
                                                  ecom_visitor_count.init();
                                                  productPage.init(); 
                                                }
                                                if ($parentSection.hasClass('page-funnel')){            
                                                  //ecomtimer.init();
                                                  progress_bar.init(); 
                                                  productPage.init(); 
                                                }
                                                if ($parentSection.hasClass('recently-viewed')){
                                                  recentlyViewed.init('.js-recently-viewed');
                                                }
                                                if ($parentSection.hasClass('slideshow-section')){
                                                  ecom_slideshow.init();
                                                }   
                                                if ($parentSection.hasClass('instagram-section')){ 
                                                  social.instagram(); 
                                                }
                                                if ($parentSection.hasClass('featured-collection-section')){
                                                  ecom_featured_collection.init();
                                                }

                                                if ($parentSection.hasClass('article-template-section')){
                                                  if(window.location.pathname.indexOf('/comments') != -1) {
                                                    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow');
                                                  }
                                                }
                                              });
                                              $(document).on('shopify:section:unload', function(e){

                                                var $target = $(e.target);
                                                var $parentSection = $('#shopify-section-' + e.detail.sectionId); 
                                                if ($parentSection.hasClass('slideshow-section')){
                                                  ecom_slideshow.unload($target);
                                                }

                                                if ($parentSection.hasClass('product-upsell-template')){
                                                  upsellProductPage.unload($target);
                                                }
                                                if ($parentSection.hasClass('cart-template')){      
                                                  productPage.init(); 
                                                }
                                                if ($parentSection.hasClass('product-template')){ 
                                                  ecomtimer.init();
                                                  progress_bar.init(); 
                                                  product_page_tabs.init(); 
                                                  ecom_visitor_count.init();
                                                  flashQTYSold.init();
                                                  productPage.unload($target);
                                                }
                                                if ($parentSection.hasClass('page-funnel')){ 
                                                  productPage.unload($target);
                                                }

                                              });
                                              /*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/

                                              Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

                                                switch (selectorIndex) {
                                                  case 0:
                                                    var key = 'root';
                                                    var selector = $(parent + ' .single-option-selector:eq(0)');
                                                    break;
                                                  case 1:
                                                    var key = $(parent + ' .single-option-selector:eq(0)').val();
                                                    var selector = $(parent + ' .single-option-selector:eq(1)');
                                                    break;
                                                  case 2:
                                                    var key = $(parent + ' .single-option-selector:eq(0)').val();
                                                    key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
                                                    var selector = $(parent + ' .single-option-selector:eq(2)');
                                                }

                                                var availableOptions = Shopify.optionsMap[key];

                                                $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
                                                  if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
                                                    $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
                                                  }
                                                  else {
                                                    $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
                                                  }
                                                });

                                              };

                                              Shopify.linkOptionSelectors = function(product, parent) {
                                                // Building our mapping object.
                                                Shopify.optionsMap = {};
                                                for (var i=0; i<product.variants.length; i++) {
                                                  var variant = product.variants[i];
                                                  if (variant.available) {
                                                    // Gathering values for the 1st drop-down.
                                                    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                                                    Shopify.optionsMap['root'].push(variant.option1);
                                                    Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
                                                    // Gathering values for the 2nd drop-down.
                                                    if (product.options.length > 1) {
                                                      var key = variant.option1;
                                                      Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                                                      Shopify.optionsMap[key].push(variant.option2);
                                                      Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                                                    }
                                                    // Gathering values for the 3rd drop-down.
                                                    if (product.options.length === 3) {
                                                      var key = variant.option1 + ' / ' + variant.option2;
                                                      Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                                                      Shopify.optionsMap[key].push(variant.option3);
                                                      Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                                                    }
                                                  }
                                                }
                                                // Update options right away.
                                                Shopify.updateOptionsInSelector(0, parent);
                                                if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
                                                if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
                                                // When there is an update in the first dropdown.
                                                $(parent + " .single-option-selector:eq(0)").change(function() {
                                                  Shopify.updateOptionsInSelector(1, parent);
                                                  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
                                                  return true;
                                                });
                                                // When there is an update in the second dropdown.
                                                $(parent + " .single-option-selector:eq(1)").change(function() {
                                                  if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
                                                  return true;
                                                });
                                              };

                                              /* option_selection.js */
                                              function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},Shopify.map=function(t,e){for(var o=[],i=0;i<t.length;i++)o.push(e(t[i],i));return o},Shopify.arrayIncludes=function(t,e){for(var o=0;o<t.length;o++)if(t[o]==e)return!0;return!1},Shopify.uniq=function(t){for(var e=[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return e},Shopify.isDefined=function(t){return"undefined"==typeof t?!1:!0},Shopify.getClass=function(t){return Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend=function(t,e){function o(){}o.prototype=e.prototype,t.prototype=new o,t.prototype.constructor=t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return window.location.search},Shopify.locationHash=function(){return window.location.hash},Shopify.replaceState=function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var e=RegExp("[?&]"+t+"=([^&#]*)").exec(Shopify.locationSearch());return e&&decodeURIComponent(e[1].replace(/\+/g," "))},Shopify.newState=function(t,e){var o;return o=Shopify.urlParam(t)?Shopify.locationSearch().replace(RegExp("("+t+"=)[^&#]+"),"$1"+e):""===Shopify.locationSearch()?"?"+t+"="+e:Shopify.locationSearch()+"&"+t+"="+e,o+Shopify.locationHash()},Shopify.setParam=function(t,e){Shopify.replaceState(Shopify.newState(t,e))},Shopify.Product=function(t){Shopify.isDefined(t)&&this.update(t)},Shopify.Product.prototype.update=function(t){for(property in t)this[property]=t[property]},Shopify.Product.prototype.optionNames=function(){return"Array"==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return null;var e=Shopify.map(this.variants,function(e){var o="option"+(t+1);return void 0==e[o]?null:e[o]});return null==e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var e=null;return t.length!=this.options.length?e:(Shopify.each(this.variants,function(o){for(var i=!0,r=0;r<t.length;r++){var n="option"+(r+1);o[n]!=t[r]&&(i=!1)}return 1==i?void(e=o):void 0}),e)},Shopify.Product.prototype.getVariantById=function(t){for(var e=0;e<this.variants.length;e++){var o=this.variants[e];if(t==o.id)return o}return null},Shopify.money_format="$",Shopify.formatMoney=function(t,e){function o(t,e){return"undefined"==typeof t?e:t}function i(t,e,i,r){if(e=o(e,2),i=o(i,","),r=o(r,"."),isNaN(t)||null==t)return 0;t=(t/100).toFixed(e);var n=t.split("."),a=n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i),s=n[1]?r+n[1]:"";return a+s}"string"==typeof t&&(t=t.replace(".",""));var r="",n=/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case"amount":r=i(t,2);break;case"amount_no_decimals":r=i(t,0);break;case"amount_with_comma_separator":r=i(t,2,".",",");break;case"amount_no_decimals_with_comma_separator":r=i(t,0,".",",")}return a.replace(n,r)},Shopify.OptionSelectors=function(t,e){return this.selectorDivClass="selector-wrapper",this.selectorClass="single-option-selector",this.variantIdFieldIdSuffix="-variant-id",this.variantIdField=null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new Shopify.Product(e.product),this.onVariantSelected=Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown=function(){var t={initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var o=this;setTimeout(function(){o.selectVariantFromParams(t)||o.fireOnChangeForFirstDropdown.call(o,t)})}},Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown=function(t){this.selectors[0].element.onchange(t)},Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown=function(t){var e=this.selectVariantFromParams(t);e||this.selectVariantFromDropdown(t)},Shopify.OptionSelectors.prototype.replaceSelector=function(t){var e=document.getElementById(t),o=e.parentNode;Shopify.each(this.buildSelectors(),function(t){o.insertBefore(t,e)}),e.style.display="none",this.variantIdField=e},Shopify.OptionSelectors.prototype.selectVariantFromDropdown=function(t){var e=document.getElementById(this.domIdPrefix).querySelector("[selected]");if(e||(e=document.getElementById(this.domIdPrefix).querySelector('[selected="selected"]')),!e)return!1;var o=e.value;return this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams=function(t){var e=Shopify.urlParam("variant");return this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant=function(t,e){var o=this.product.getVariantById(t);if(null==o)return!1;for(var i=0;i<this.selectors.length;i++){var r=this.selectors[i].element,n=r.getAttribute("data-option"),a=o[n];null!=a&&this.optionExistInSelect(r,a)&&(r.value=a)}return"undefined"!=typeof jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect=function(t,e){for(var o=0;o<t.options.length;o++)if(t.options[o].value==e)return!0},Shopify.OptionSelectors.prototype.insertSelectors=function(t,e){Shopify.isDefined(e)&&this.setMessageElement(e),this.domIdPrefix="product-"+this.product.id+"-variant-selector";var o=document.getElementById(t);Shopify.each(this.buildSelectors(),function(t){o.appendChild(t)})},Shopify.OptionSelectors.prototype.buildSelectors=function(){for(var t=0;t<this.product.optionNames().length;t++){var e=new Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled=!1,this.selectors.push(e)}var o=this.selectorDivClass,i=this.product.optionNames(),r=Shopify.map(this.selectors,function(t){var e=document.createElement("div");if(e.setAttribute("class",o),i.length>=1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o=this.selectors[e].element.value;t.push(o)}return t},Shopify.OptionSelectors.prototype.updateSelectors=function(t,e){var o=this.selectedValues(),i=this.product.getVariant(o);i?(this.variantIdField.disabled=!1,this.variantIdField.value=i.id):this.variantIdField.disabled=!0,this.onVariantSelected(i,this,e),null!=this.historyState&&this.historyState.onVariantChange(i,this,e)},Shopify.OptionSelectorsFromDOM=function(t,e){var o=e.optionNames||[],i=e.priceFieldExists||!0,r=e.delimiter||"/",n=this.createProductFromSelector(t,o,i,r);e.product=n,Shopify.OptionSelectorsFromDOM.baseConstructor.call(this,t,e)},Shopify.extend(Shopify.OptionSelectorsFromDOM,Shopify.OptionSelectors),Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector=function(t,e,o,i){if(!Shopify.isDefined(o))var o=!0;if(!Shopify.isDefined(i))var i="/";var r=document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&"option"==t.tagName.toLowerCase()){var n=t.innerHTML.split(new RegExp("\\s*\\"+i+"\\s*"));0==e.length&&(a=n.length-(o?1:0));var p=n.slice(0,a),l=o?n[a]:"",c=(t.getAttribute("value"),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var p={variants:s};if(0==e.length){p.options=[];for(var l=0;a>l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n=document.createElement("option");n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id=t.domIdPrefix+"-option-"+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var o=0;o<t.length;o++){var i=t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new Image).src=t},switchImage:function(t,e,o){if(t&&e){var i=this.imageSize(e.src),r=this.getSizedImageUrl(t.src,i);o?o(r,t,e):e.src=r}},imageSize:function(t){var e=t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return null!=e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return t;if("master"==e)return this.removeProtocol(t);var o=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(null!=o){var i=t.split(o[0]),r=o[0];return this.removeProtocol(i[0]+"_"+e+r)}return null},removeProtocol:function(t){return t.replace(/http(s)?:/,"")}},Shopify.OptionSelectors.HistoryState=function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener("popstate",function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam("variant",t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return window.history&&window.history.replaceState};
                                              /*! js-url - v2.5.0 - 2017-04-22 */
                                              !function(){var a=function(){function a(){}function b(a){return decodeURIComponent(a.replace(/\+/g," "))}function c(a,b){var c=a.charAt(0),d=b.split(c);return c===a?d:(a=parseInt(a.substring(1),10),d[a<0?d.length+a:a-1])}function d(a,c){for(var d=a.charAt(0),e=c.split("&"),f=[],g={},h=[],i=a.substring(1),j=0,k=e.length;j<k;j++)if(f=e[j].match(/(.*?)=(.*)/),f||(f=[e[j],e[j],""]),""!==f[1].replace(/\s/g,"")){if(f[2]=b(f[2]||""),i===f[1])return f[2];h=f[1].match(/(.*)\[([0-9]+)\]/),h?(g[h[1]]=g[h[1]]||[],g[h[1]][h[2]]=f[2]):g[f[1]]=f[2]}return d===a?g:g[i]}return function(b,e){var f,g={};if("tld?"===b)return a();if(e=e||window.location.toString(),!b)return e;if(b=b.toString(),f=e.match(/^mailto:([^\/].+)/))g.protocol="mailto",g.email=f[1];else{if((f=e.match(/(.*?)\/#\!(.*)/))&&(e=f[1]+f[2]),(f=e.match(/(.*?)#(.*)/))&&(g.hash=f[2],e=f[1]),g.hash&&b.match(/^#/))return d(b,g.hash);if((f=e.match(/(.*?)\?(.*)/))&&(g.query=f[2],e=f[1]),g.query&&b.match(/^\?/))return d(b,g.query);if((f=e.match(/(.*?)\:?\/\/(.*)/))&&(g.protocol=f[1].toLowerCase(),e=f[2]),(f=e.match(/(.*?)(\/.*)/))&&(g.path=f[2],e=f[1]),g.path=(g.path||"").replace(/^([^\/])/,"/$1"),b.match(/^[\-0-9]+$/)&&(b=b.replace(/^([^\/])/,"/$1")),b.match(/^\//))return c(b,g.path.substring(1));if(f=c("/-1",g.path.substring(1)),f&&(f=f.match(/(.*?)\.(.*)/))&&(g.file=f[0],g.filename=f[1],g.fileext=f[2]),(f=e.match(/(.*)\:([0-9]+)$/))&&(g.port=f[2],e=f[1]),(f=e.match(/(.*?)@(.*)/))&&(g.auth=f[1],e=f[2]),g.auth&&(f=g.auth.match(/(.*)\:(.*)/),g.user=f?f[1]:g.auth,g.pass=f?f[2]:void 0),g.hostname=e.toLowerCase(),"."===b.charAt(0))return c(b,g.hostname);a()&&(f=g.hostname.match(a()),f&&(g.tld=f[3],g.domain=f[2]?f[2]+"."+f[3]:void 0,g.sub=f[1]||void 0)),g.port=g.port||("https"===g.protocol?"443":"80"),g.protocol=g.protocol||("443"===g.port?"https":"http")}return b in g?g[b]:"{}"===b?g:void 0}}();"function"==typeof window.define&&window.define.amd?window.define("js-url",[],function(){return a}):("undefined"!=typeof window.jQuery&&window.jQuery.extend({url:function(a,b){return window.url(a,b)}}),window.url=a)}();
                                              //Timer
                                              !function(t){function n(n,u){var l=t.extend({},t.fn.countdowntimer.defaults,u);(n=n).addClass("style");var H,M,h,v;if(H=l.size,M=l.borderColor,h=l.fontColor,v=l.backgroundColor,void 0!=u.regexpMatchFormat&&void 0!=u.regexpReplaceWith&&void 0==u.timeSeparator&&(window["regexpMatchFormat_"+n.attr("id")]=u.regexpMatchFormat,window["regexpReplaceWith_"+n.attr("id")]=u.regexpReplaceWith),void 0!=u.borderColor||void 0!=u.fontColor||void 0!=u.backgroundColor){var g={background:v,color:h,"border-color":M};n.css(g)}else n.addClass("colorDefinition");if(void 0!=u.size)switch(H){case"xl":n.addClass("size_xl");break;case"lg":n.addClass("size_lg");break;case"md":n.addClass("size_md");break;case"sm":n.addClass("size_sm");break;case"xs":n.addClass("size_xs")}else"sm"==H&&n.addClass("size_sm");if(void 0!=u.startDate||void 0!=u.dateAndTime||void 0!=u.currentTime||void 0==u.hours&&void 0==u.minutes&&void 0==u.seconds)if(void 0!=u.startDate&&void 0!=u.dateAndTime&&void 0==u.currentTime){startDate="",endDate="",timer_startDate="",window["startDate"+n.attr("id")]=new Date(l.startDate),window["endDate"+n.attr("id")]=new Date(l.dateAndTime),a(n,l,p="withStart"),window["timer_startDate"+n.attr("id")]=setInterval(function(){a(n,l,p)},1e3*l.tickInterval)}else if(void 0==u.startDate&&void 0!=u.dateAndTime&&void 0==u.currentTime){startTime="",dateTime="",timer_givenDate="";var p,I=l.startDate.getHours()<10?"0"+l.startDate.getHours():l.startDate.getHours(),k=l.startDate.getMinutes()<10?"0"+l.startDate.getMinutes():l.startDate.getMinutes(),f=l.startDate.getSeconds()<10?"0"+l.startDate.getSeconds():l.startDate.getSeconds(),D=l.startDate.getMonth()+1<10?"0"+(l.startDate.getMonth()+1):l.startDate.getMonth()+1,x=l.startDate.getDate()<10?"0"+l.startDate.getDate():l.startDate.getDate(),T=l.startDate.getFullYear();window["startTime"+n.attr("id")]=new Date(T+"/"+D+"/"+x+" "+I+":"+k+":"+f),window["dateTime"+n.attr("id")]=new Date(l.dateAndTime),a(n,l,p="withnoStart"),window["timer_givenDate"+n.attr("id")]=setInterval(function(){a(n,l,p)},1e3*l.tickInterval)}else void 0!=u.currentTime?(currentTime="",timer_currentDate="",window["currentTime"+n.attr("id")]=l.currentTime,_(n,l),window["timer_currentDate"+n.attr("id")]=setInterval(function(){_(n,l)},1e3*l.tickInterval)):(countSeconds="",timer_secondsTimer="",window["countSeconds"+n.attr("id")]=l.seconds,window["timer_secondsTimer"+n.attr("id")]=setInterval(function(){var t,e;e=(t=n).attr("id"),window["countSeconds"+e].toString().length<2&&(window["countSeconds"+e]="0"+window["countSeconds"+e]),c(t,window["countSeconds"+e]+" sec"),window["countSeconds"+e]--,-1==window["countSeconds"+e]&&(delete window["countSeconds"+e],clearInterval(window["timer_secondsTimer"+e])),e=null},1e3));else void 0!=u.hours&&void 0==u.minutes&&void 0==u.seconds?(hours_H="",minutes_H="",seconds_H="",timer_H="",window["hours_H"+n.attr("id")]=l.hours,window["minutes_H"+n.attr("id")]=l.minutes,window["seconds_H"+n.attr("id")]=l.seconds,void 0!=u.pauseButton&&S(n,"H",l,e),void 0!=u.stopButton&&m(n,"H",l,e),e(n,l),window["timer_H"+n.attr("id")]=setInterval(function(){e(n,l)},1e3*l.tickInterval)):void 0==u.hours&&void 0!=u.minutes&&void 0==u.seconds?(hours_M="",minutes_M="",seconds_M="",timer_M="",window["hours_M"+n.attr("id")]=l.hours,window["minutes_M"+n.attr("id")]=l.minutes,window["seconds_M"+n.attr("id")]=l.seconds,void 0!=u.pauseButton&&S(n,"M",l,o),void 0!=u.stopButton&&m(n,"M",l,o),o(n,l),window["timer_M"+n.attr("id")]=setInterval(function(){o(n,l)},1e3*l.tickInterval)):void 0==u.hours&&void 0==u.minutes&&void 0!=u.seconds?(hours_S="",minutes_S="",seconds_S="",timer_S="",window["hours_S"+n.attr("id")]=l.hours,window["minutes_S"+n.attr("id")]=l.minutes,window["seconds_S"+n.attr("id")]=l.seconds,void 0!=u.pauseButton&&S(n,"S",l,i),void 0!=u.stopButton&&m(n,"S",l,i),i(n,l),window["timer_S"+n.attr("id")]=setInterval(function(){i(n,l)},1e3*l.tickInterval)):void 0!=u.hours&&void 0!=u.minutes&&void 0==u.seconds?(hours_HM="",minutes_HM="",seconds_HM="",timer_HM="",window["hours_HM"+n.attr("id")]=l.hours,window["minutes_HM"+n.attr("id")]=l.minutes,window["seconds_HM"+n.attr("id")]=l.seconds,void 0!=u.pauseButton&&S(n,"HM",l,w),void 0!=u.stopButton&&m(n,"HM",l,w),w(n,l),window["timer_HM"+n.attr("id")]=setInterval(function(){w(n,l)},1e3*l.tickInterval)):void 0==u.hours&&void 0!=u.minutes&&void 0!=u.seconds?(hours_MS="",minutes_MS="",seconds_MS="",timer_MS="",window["hours_MS"+n.attr("id")]=l.hours,window["minutes_MS"+n.attr("id")]=l.minutes,window["seconds_MS"+n.attr("id")]=l.seconds,void 0!=u.pauseButton&&S(n,"MS",l,d),void 0!=u.stopButton&&m(n,"MS",l,d),d(n,l),window["timer_MS"+n.attr("id")]=setInterval(function(){d(n,l)},1e3*l.tickInterval)):void 0!=u.hours&&void 0==u.minutes&&void 0!=u.seconds?(hours_HS="",minutes_HS="",seconds_HS="",timer_HS="",window["hours_HS"+n.attr("id")]=l.hours,window["minutes_HS"+n.attr("id")]=l.minutes,window["seconds_HS"+n.attr("id")]=l.seconds,void 0!=u.pauseButton&&S(n,"HS",l,s),void 0!=u.stopButton&&m(n,"HS",l,s),s(n,l),window["timer_HS"+n.attr("id")]=setInterval(function(){s(n,l)},1e3*l.tickInterval)):void 0!=u.hours&&void 0!=u.minutes&&void 0!=u.seconds&&(hours_HMS="",minutes_HMS="",seconds_HMS="",timer_HMS="",window["hours_HMS"+n.attr("id")]=l.hours,window["minutes_HMS"+n.attr("id")]=l.minutes,window["seconds_HMS"+n.attr("id")]=l.seconds,void 0!=u.pauseButton&&S(n,"HMS",l,r),void 0!=u.stopButton&&m(n,"HMS",l,r),r(n,l),window["timer_HMS"+n.attr("id")]=setInterval(function(){r(n,l)},1e3*l.tickInterval))}function e(t,n){var e=t.attr("id");window["minutes_H"+e]==n.minutes&&window["seconds_H"+e]==n.seconds&&window["hours_H"+e]==n.hours?(window["hours_H"+e].toString().length<2&&(window["hours_H"+e]="0"+window["hours_H"+e]),c(t,window["hours_H"+e]+n.timeSeparator+"00"+n.timeSeparator+"00"),window["seconds_H"+e]=60-n.tickInterval,window["minutes_H"+e]=59,0!=window["hours_H"+e]?window["hours_H"+e]--:(delete window["hours_H"+e],delete window["minutes_H"+e],delete window["seconds_H"+e],clearInterval(window["timer_H"+e]),u(t,n))):(window["hours_H"+e].toString().length<2&&(window["hours_H"+e]="0"+window["hours_H"+e]),window["minutes_H"+e].toString().length<2&&(window["minutes_H"+e]="0"+window["minutes_H"+e]),window["seconds_H"+e].toString().length<2&&(window["seconds_H"+e]="0"+window["seconds_H"+e]),c(t,window["hours_H"+e]+n.timeSeparator+window["minutes_H"+e]+n.timeSeparator+window["seconds_H"+e]),window["seconds_H"+e]-=n.tickInterval,0!=window["minutes_H"+e]&&window["seconds_H"+e]<0&&(window["minutes_H"+e]--,window["seconds_H"+e]=60-n.tickInterval),0==window["minutes_H"+e]&&window["seconds_H"+e]<0&&0!=window["hours_H"+e]&&(window["hours_H"+e]--,window["minutes_H"+e]=59,window["seconds_H"+e]=60-n.tickInterval),0==window["minutes_H"+e]&&window["seconds_H"+e]<0&&0==window["hours_H"+e]&&(delete window["hours_H"+e],delete window["minutes_H"+e],delete window["seconds_H"+e],clearInterval(window["timer_H"+e]),u(t,n))),e=null}function o(t,n){var e=t.attr("id");window["minutes_M"+e]==n.minutes&&window["seconds_M"+e]==n.seconds?(window["minutes_M"+e].toString().length<2&&(window["minutes_M"+e]="0"+window["minutes_M"+e]),c(t,window["minutes_M"+e]+n.timeSeparator+"00"),window["seconds_M"+e]=60-n.tickInterval,0!=window["minutes_M"+e]?window["minutes_M"+e]--:(delete window["hours_M"+e],delete window["minutes_M"+e],delete window["seconds_M"+e],clearInterval(window["timer_M"+e]),u(t,n))):(window["minutes_M"+e].toString().length<2&&(window["minutes_M"+e]="0"+window["minutes_M"+e]),window["seconds_M"+e].toString().length<2&&(window["seconds_M"+e]="0"+window["seconds_M"+e]),c(t,window["minutes_M"+e]+n.timeSeparator+window["seconds_M"+e]),window["seconds_M"+e]-=n.tickInterval,0!=window["minutes_M"+e]&&window["seconds_M"+e]<0&&(window["minutes_M"+e]--,window["seconds_M"+e]=60-n.tickInterval),0==window["minutes_M"+e]&&window["seconds_M"+e]<0&&(delete window["hours_M"+e],delete window["minutes_M"+e],delete window["seconds_M"+e],clearInterval(window["timer_M"+e]),u(t,n))),e=null}function i(t,n){var e=t.attr("id");window["seconds_S"+e].toString().length<2&&(window["seconds_S"+e]="0"+window["seconds_S"+e]),c(t,window["seconds_S"+e]+" sec"),window["seconds_S"+e]-=n.tickInterval,window["seconds_S"+e]<0&&(delete window["hours_S"+e],delete window["minutes_S"+e],delete window["seconds_S"+e],clearInterval(window["timer_S"+e]),u(t,n)),e=null}function w(t,n){var e=t.attr("id");window["minutes_HM"+e]==n.minutes&&window["hours_HM"+e]==n.hours?(window["hours_HM"+e].toString().length<2&&(window["hours_HM"+e]="0"+window["hours_HM"+e]),window["minutes_HM"+e].toString().length<2&&(window["minutes_HM"+e]="0"+window["minutes_HM"+e]),c(t,window["hours_HM"+e]+n.timeSeparator+window["minutes_HM"+e]+n.timeSeparator+"00"),0!=window["hours_HM"+e]&&0==window["minutes_HM"+e]?(window["hours_HM"+e]--,window["minutes_HM"+e]=59,window["seconds_HM"+e]=60-n.tickInterval):(0==window["hours_HM"+e]&&window["minutes_HM"+e],window["seconds_HM"+e]=60-n.tickInterval,window["minutes_HM"+e]--),0==window["hours_HM"+e]&&0==window["minutes_HM"+e]&&60==window["seconds_HM"+e]&&(delete window["hours_HM"+e],delete window["minutes_HM"+e],delete window["seconds_HM"+e],clearInterval(window["timer_HM"+e]),u(t,n))):(window["hours_HM"+e].toString().length<2&&(window["hours_HM"+e]="0"+window["hours_HM"+e]),window["minutes_HM"+e].toString().length<2&&(window["minutes_HM"+e]="0"+window["minutes_HM"+e]),window["seconds_HM"+e].toString().length<2&&(window["seconds_HM"+e]="0"+window["seconds_HM"+e]),c(t,window["hours_HM"+e]+n.timeSeparator+window["minutes_HM"+e]+n.timeSeparator+window["seconds_HM"+e]),window["seconds_HM"+e]-=n.tickInterval,0!=window["minutes_HM"+e]&&window["seconds_HM"+e]<0&&(window["minutes_HM"+e]--,window["seconds_HM"+e]=60-n.tickInterval),0==window["minutes_HM"+e]&&window["seconds_HM"+e]<0&&0!=window["hours_HM"+e]&&(window["hours_HM"+e]--,window["minutes_HM"+e]=59,window["seconds_HM"+e]=60-n.tickInterval),0==window["minutes_HM"+e]&&window["seconds_HM"+e]<0&&0==window["hours_HM"+e]&&(delete window["hours_HM"+e],delete window["minutes_HM"+e],delete window["seconds_HM"+e],clearInterval(window["timer_HM"+e]),u(t,n))),e=null}function d(t,n){var e=t.attr("id");window["minutes_MS"+e]==n.minutes&&window["seconds_MS"+e]==n.seconds?(window["minutes_MS"+e].toString().length<2&&(window["minutes_MS"+e]="0"+window["minutes_MS"+e]),window["seconds_MS"+e].toString().length<2&&(window["seconds_MS"+e]="0"+window["seconds_MS"+e]),c(t,window["minutes_MS"+e]+n.timeSeparator+window["seconds_MS"+e]),0!=window["minutes_MS"+e]&&0==window["seconds_MS"+e]?(window["minutes_MS"+e]--,window["seconds_MS"+e]=60-n.tickInterval):0==window["minutes_MS"+e]&&0==window["seconds_MS"+e]?(delete window["hours_MS"+e],delete window["minutes_MS"+e],delete window["seconds_MS"+e],clearInterval(window["timer_MS"+e]),u(t,n)):window["seconds_MS"+e]-=n.tickInterval):(window["minutes_MS"+e].toString().length<2&&(window["minutes_MS"+e]="0"+window["minutes_MS"+e]),window["seconds_MS"+e].toString().length<2&&(window["seconds_MS"+e]="0"+window["seconds_MS"+e]),c(t,window["minutes_MS"+e]+n.timeSeparator+window["seconds_MS"+e]),window["seconds_MS"+e]-=n.tickInterval,0!=window["minutes_MS"+e]&&window["seconds_MS"+e]<0&&(window["minutes_MS"+e]--,window["seconds_MS"+e]=60-n.tickInterval),0==window["minutes_MS"+e]&&window["seconds_MS"+e]<0&&(delete window["hours_MS"+e],delete window["minutes_MS"+e],delete window["seconds_MS"+e],clearInterval(window["timer_MS"+e]),u(t,n))),e=null}function s(t,n){var e=t.attr("id");window["seconds_HS"+e]==n.seconds&&window["hours_HS"+e]==n.hours?(window["hours_HS"+e].toString().length<2&&(window["hours_HS"+e]="0"+window["hours_HS"+e]),window["seconds_HS"+e].toString().length<2&&(window["seconds_HS"+e]="0"+window["seconds_HS"+e]),c(t,window["hours_HS"+e]+n.timeSeparator+"00"+n.timeSeparator+window["seconds_HS"+e]),0==window["hours_HS"+e]&&0==window["seconds_HS"+e]?(delete window["hours_HS"+e],delete window["minutes_HS"+e],delete window["seconds_HS"+e],clearInterval(window["timer_HS"+e]),u(t,n)):0!=window["hours_HS"+e]&&0==window["seconds_HS"+e]?(window["hours_HS"+e]--,window["minutes_HS"+e]=59,window["seconds_HS"+e]=60-n.tickInterval):window["seconds_HS"+e]-=n.tickInterval):(window["hours_HS"+e].toString().length<2&&(window["hours_HS"+e]="0"+window["hours_HS"+e]),window["minutes_HS"+e].toString().length<2&&(window["minutes_HS"+e]="0"+window["minutes_HS"+e]),window["seconds_HS"+e].toString().length<2&&(window["seconds_HS"+e]="0"+window["seconds_HS"+e]),c(t,window["hours_HS"+e]+n.timeSeparator+window["minutes_HS"+e]+n.timeSeparator+window["seconds_HS"+e]),window["seconds_HS"+e]-=n.tickInterval,0!=window["minutes_HS"+e]&&window["seconds_HS"+e]<0&&(window["minutes_HS"+e]--,window["seconds_HS"+e]=60-n.tickInterval),0==window["minutes_HS"+e]&&window["seconds_HS"+e]<0&&0!=window["hours_HS"+e]&&(window["hours_HS"+e]--,window["minutes_HS"+e]=59,window["seconds_HS"+e]=60-n.tickInterval),0==window["minutes_HS"+e]&&window["seconds_HS"+e]<0&&0==window["hours_HS"+e]&&(delete window["hours_HS"+e],delete window["minutes_HS"+e],delete window["seconds_HS"+e],clearInterval(window["timer_HS"+e]),u(t,n))),e=null}function r(t,n){var e=t.attr("id");document.cookie="hours="+window["hours_HMS"+e],document.cookie="minutes="+window["minutes_HMS"+e],document.cookie="seconds="+window["seconds_HMS"+e],window["minutes_HMS"+e]==n.minutes&&window["seconds_HMS"+e]==n.seconds&&window["hours_HMS"+e]==n.hours?(window["hours_HMS"+e].toString().length<2&&(window["hours_HMS"+e]="0"+window["hours_HMS"+e]),window["minutes_HMS"+e].toString().length<2&&(window["minutes_HMS"+e]="0"+window["minutes_HMS"+e]),window["seconds_HMS"+e].toString().length<2&&(window["seconds_HMS"+e]="0"+window["seconds_HMS"+e]),c(t,"<samp class='hour_timer text-left'>"+window["hours_HMS"+e]+"</samp>"+n.timeSeparator+"<samp class='minute_timer'>"+window["minutes_HMS"+e]+"</samp>"+n.timeSeparator+"<samp class='second_timer text-right'>"+window["seconds_HMS"+e]+"</samp>"),0==window["hours_HMS"+e]&&0==window["minutes_HMS"+e]&&0==window["seconds_HMS"+e]?(delete window["hours_HMS"+e],delete window["minutes_HMS"+e],delete window["seconds_HMS"+e],clearInterval(window["timer_HMS"+e]),u(t,n)):0!=window["hours_HMS"+e]&&0==window["minutes_HMS"+e]&&0==window["seconds_HMS"+e]?(window["hours_HMS"+e]--,window["minutes_HMS"+e]=59,window["seconds_HMS"+e]=60-n.tickInterval):0==window["hours_HMS"+e]&&0!=window["minutes_HMS"+e]&&0==window["seconds_HMS"+e]?(window["minutes_HMS"+e]--,window["seconds_HMS"+e]=60-n.tickInterval):0!=window["hours_HMS"+e]&&0!=window["minutes_HMS"+e]&&0==window["seconds_HMS"+e]?(window["minutes_HMS"+e]--,window["seconds_HMS"+e]=60-n.tickInterval):window["seconds_HMS"+e]-=n.tickInterval):(window["hours_HMS"+e].toString().length<2&&(window["hours_HMS"+e]="0"+window["hours_HMS"+e]),window["minutes_HMS"+e].toString().length<2&&(window["minutes_HMS"+e]="0"+window["minutes_HMS"+e]),window["seconds_HMS"+e].toString().length<2&&(window["seconds_HMS"+e]="0"+window["seconds_HMS"+e]),c(t,"<samp class='hour_timer text-left'>"+window["hours_HMS"+e]+"</samp>"+n.timeSeparator+"<samp class='minute_timer'>"+window["minutes_HMS"+e]+"</samp>"+n.timeSeparator+"<samp class='second_timer text-right'>"+window["seconds_HMS"+e]+"</samp>"),window["seconds_HMS"+e]-=n.tickInterval,0!=window["minutes_HMS"+e]&&window["seconds_HMS"+e]<0&&(window["minutes_HMS"+e]--,window["seconds_HMS"+e]=60-n.tickInterval),0==window["minutes_HMS"+e]&&window["seconds_HMS"+e]<0&&0!=window["hours_HMS"+e]&&(window["hours_HMS"+e]--,window["minutes_HMS"+e]=59,window["seconds_HMS"+e]=60-n.tickInterval),0==window["minutes_HMS"+e]&&window["seconds_HMS"+e]<0&&0==window["hours_HMS"+e]&&(delete window["hours_HMS"+e],delete window["minutes_HMS"+e],delete window["seconds_HMS"+e],clearInterval(window["timer_HMS"+e]),u(t,n))),e=null}function a(t,n,e){var o=t.attr("id"),i="withnoStart"==e?window["dateTime"+o]:window["endDate"+o],w="withnoStart"==e?window["startTime"+o]:window["startDate"+o],d=Math.floor((i-w)/864e5),s=Math.floor((i-w)%864e5/36e5),r=Math.floor((i-w)%864e5/6e4)%60,a=Math.floor((i-w)%864e5/1e3)%60%60;i-w>0?(d.toString().length<2&&(d="0"+d),s.toString().length<2&&(s="0"+s),r.toString().length<2&&(r="0"+r),a.toString().length<2&&(a="0"+a),c(t,d+n.timeSeparator+s+n.timeSeparator+r+n.timeSeparator+a),"withnoStart"==e?window["startTime"+o].setSeconds(window["startTime"+o].getSeconds()+n.tickInterval):window["startDate"+o].setSeconds(window["startDate"+o].getSeconds()+n.tickInterval)):(c(t,"00"+n.timeSeparator+"00"+n.timeSeparator+"00"+n.timeSeparator+"00"),"withnoStart"==e?(delete window["dateTime"+o],delete window["startTime"+o],clearInterval(window["timer_givenDate"+o])):"withStart"==e&&(delete window["startDate"+o],delete window["endDate"+o],clearInterval(window["timer_startDate"+o])),u(t,n)),o=null}function _(t,n){if(1==window["currentTime"+t.attr("id")]){var e=new Date,o=e.getHours(),i=e.getMinutes(),w=e.getSeconds();o.toString().length<2&&(o="0"+o),i.toString().length<2&&(i="0"+i),w.toString().length<2&&(w="0"+w),c(t,o+n.timeSeparator+i+n.timeSeparator+w)}else alert("Set Current Time option.")}function u(n,e){null!=e.timeUp&&1==t.isFunction(e.timeUp)&&e.timeUp.apply(n,[]),null!=e.expiryUrl&&(window.location=e.expiryUrl)}function c(t,n){var e=n;if(void 0!==window["regexpMatchFormat_"+t.attr("id")]&&void 0!==window["regexpReplaceWith_"+t.attr("id")]){var o=new RegExp(window["regexpMatchFormat_"+t.attr("id")]);e=n.replace(o,window["regexpReplaceWith_"+t.attr("id")])}t.html(e)}function S(n,e,o,i){t("#"+o.pauseButton).click(function(){"resume"!=t(this).val()?(t("#"+o.pauseButton).val("resume").text("Resume"),clearInterval(window["timer_"+e+n.attr("id")])):"resume"==t(this).val()&&(t("#"+o.pauseButton).val("pause").text("Pause"),window["timer_"+e+n.attr("id")]=setInterval(function(){i(n,o)},1e3*o.tickInterval))})}function m(n,e,o,i){t("#"+o.stopButton).click(function(){"start"!=t(this).val()?(t("#"+o.stopButton).val("start").text("Start"),clearInterval(window["timer_"+e+n.attr("id")]),window["hours_"+e+n.attr("id")]=o.hours,window["minutes_"+e+n.attr("id")]=o.minutes,window["seconds_"+e+n.attr("id")]=o.seconds,i(n,o)):"start"==t(this).val()&&(t("#"+o.stopButton).val("stop").text("Stop"),window["timer_"+e+n.attr("id")]=setInterval(function(){i(n,o)},1e3*o.tickInterval))})}t.fn.countdowntimer=function(e){return this.each(function(){n(t(this),e)})},t.fn.countdowntimer.defaults={hours:0,minutes:0,seconds:60,startDate:new Date,dateAndTime:new Date("0000/00/00 00:00:00"),currentTime:!1,size:"sm",borderColor:"#F0068E",fontColor:"#FFFFFF",backgroundColor:"#000000",timeSeparator:"<span>:</span>",tickInterval:1,timeUp:null,expiryUrl:null,regexpMatchFormat:null,regexpReplaceWith:null,pauseButton:null,stopButton:null}}(jQuery);
     //Product feature Inventory Bar
function randomIntFromInterval(a,b){return Math.floor(Math.random()*(b-a+1)+a)}
var total_items=50,d=new Date,ran=randomIntFromInterval(12,14);console.log(ran);var inventory_text=$("#inventory_text").html(),decrease_after=15,decrease_after_first_item=.15,min_of_remaining_items=1,remaining_items=randomIntFromInterval(12,15),first_text=$(".progress_bar").attr("data-inventory-left"),last_text=$(".progress_bar").attr("data-inventory-right");!function(a){function b(a){var b=100*remaining_items/total_items;remaining_items<10&&a.find(".progressbar div:first").addClass("less-than-ten"),a.find(".progressbar").addClass("active progress-striped"),setTimeout(function(){myanimate(a.find(".progressbar div:first"),b),a.find(".progressbar").removeClass("active progress-striped")},1e3)}
a.fn.progressbar=function(){var c=remaining_items;this.addClass("items-count"),$(".count").html(c),b(this);var d=this;setTimeout(function(){remaining_items--,remaining_items<min_of_remaining_items&&(remaining_items=randomIntFromInterval(12,15)),a(".count").css("background-color","#E04848"),a(".count").css("color","#fff"),a(".count").css("border-radius","5px"),setTimeout(function(){a(".count").css("background-color","#fff"),a(".count").css("color","#A94442")},1800),d.find(".count").text(remaining_items),b(d)},6e4*decrease_after_first_item),setInterval(function(){remaining_items--,remaining_items<min_of_remaining_items&&(remaining_items=randomIntFromInterval(12,15)),a(".count").css("background-color","#E04848"),a(".count").css("color","#fff"),a(".count").css("border-radius","5px"),setTimeout(function(){a(".count").css("background-color","#fff"),a(".count").css("color","#A94442")},1800),d.find(".count").text(remaining_items),b(d)},6e4*decrease_after)}}(jQuery);function myanimate(s,t){var a=0,r=parseInt(s.closest(".progressbar").css("width")),e=Math.floor(100*parseInt(s.css("width"))/r);e>t&&(a=e);var n=setInterval(function(){e>t?a--:a++,s.css("width",a+"%"),(a==t||a<=0||a>=100)&&clearInterval(n)},40)}
  //Currency convert with Country
          
                      /**New**/
jQuery(document).ready(function($){
  //if you change this breakpoint in the style.css file (or _layout.scss if you use SASS), don't forget to update this value as well
  var $L = 1200,
      $menu_navigation = $('#main-nav'),
      $hamburger_icon = $('#cd-hamburger-menu'),
      $cart_trigger = $('.cd-cart-trigger'),
      $lateral_cart = $('#cd-cart'),
      $shadow_layer = $('#cd-shadow-layer'),
      $closs_pop = $('.pop-close');
  //open lateral menu on mobile
  $hamburger_icon.on('click', function(event){
    event.preventDefault();
    //close cart panel (if it's open)
    $lateral_cart.removeClass('speed-in');
    toggle_panel_visibility($menu_navigation, $shadow_layer, $('body'));
  });
  //open cart
  $cart_trigger.on('click', function(event){
    event.preventDefault();
    //close lateral menu (if it's open)
    toggle_panel_visibility($lateral_cart, $shadow_layer, $('body'));
  });

  //close lateral cart or lateral menu
  $shadow_layer.on('click', function(){
    $shadow_layer.removeClass('is-visible');
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    if( $lateral_cart.hasClass('speed-in') ) {
      $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        $('body').removeClass('overflow-hidden');
      });
    } else {
      $lateral_cart.removeClass('speed-in');
    }
  });
  //close lateral cart or lateral menu
  $closs_pop.on('click', function(){
    $shadow_layer.removeClass('is-visible');
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    if( $lateral_cart.hasClass('speed-in') ) {
      $lateral_cart.removeClass('speed-in').on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
        $('body').removeClass('overflow-hidden');
      });
    } else {
      $lateral_cart.removeClass('speed-in');
    }
  });
});

function toggle_panel_visibility ($lateral_panel, $background_layer, $body) {
  if( $lateral_panel.hasClass('speed-in') ) {
    // firefox transitions break when parent overflow is changed, so we need to wait for the end of the trasition to give the body an overflow hidden
    $lateral_panel.removeClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
      $body.removeClass('overflow-hidden');
    });
    $background_layer.removeClass('is-visible');

  } else {
    $lateral_panel.addClass('speed-in').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
      $body.addClass('overflow-hidden');
    });
    $background_layer.addClass('is-visible');
  }
}

